import React, { useState, useEffect, useRef } from "react";
import "./style.css";
import domtoimage from "dom-to-image";
import ReactEcharts from "echarts-for-react";
import * as echarts from "echarts";
import * as $ from "jquery";

import Checkbox from "@mui/material/Checkbox";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Button from "@mui/material/Button";
import DataTable from "react-data-table-component";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";

// import ExploreVisualiseModal from "../data-search/explore-visualise-modal";
import dataSearchResultLang from '../../../Config/data-search-results-component.json';

import Dropdown from "react-bootstrap/Dropdown";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';

import { useSelector } from "react-redux";
import geoJSONData2 from "../../../Config/map/json/level2.json";
// import geoJSONData2 from "../../../Config/map/json/TLS_L02_2019.json";
// import geoJSONData3 from "../../../Config/map/json/TLS_L03_2019.json";
// import geoJSONData4 from "../../../Config/map/json/TLS_L04_2019.json";
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  FacebookIcon,
  LinkedinIcon,
  TwitterIcon,
} from 'react-share';
import * as constants from "../../../../src/Config/app.constants";
import adminService from "../../../services/admin.service";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;



function DataSearchResultChart(props) {
  // const colorPalette = ["#B8372B", "#CF655B", "#ED9C94", "#FFCBC6"].reverse();
 
  const formatUtil = echarts.format;
  const chart = useRef(null);
  const fbShareButton = useRef(null);
  const lnShareButton = useRef(null);
  const twShareButton = useRef(null);
  let { data, type } = props;

  const [title, setTitle] = useState("");
  const [showData, setShowData] = useState([]);
  // const lang = useSelector((state) => state.lang.lang);
  const lang = 'en';
  const [loader, setLoader] = useState(false);
  const [swap, setSwap] = useState(false);

  const [noData, setNoData] = useState(false)
  // =============================================================
  const [indicator, setIndicator] = useState("");
  const [timeperiod, setTimeperiod] = useState("");
  const [source, setSource] = useState([]);
  const [zoomData, setZoomData] = useState(1.25);
  const [isCompass, setIsCompass] = useState(false);
  const [dat, setDat] = useState([]);
  const [srcList, setSourceList] = useState([]);
  // =============================================================
  const [colorPalette, setColorPalette] = useState(["#A01929", "#B71D2F", "#CE2035", "#E5243B", "#E83A4F", "#EA5062", "#ED6676", "#EF7C89", "#EDA2AA"].reverse());

  const [showAllSelected, setShowAllSelected] = useState(false);
  let chartInstance = null;

  const [label, setLabel] = useState(false);
  const [legend, setLegend] = useState([]);
  const [lgend, setLgend] = useState(true);
  const [flag, setFlag] = useState(false);
  const [itFlag, setITFlag] = useState(true);
  const [mapState, setMapState] = useState({
    // uniDisasters: [],
    // uniForms: [],
    uniIndicators: [],
    uniNewIndicators: [],
    uniTP: [],
    uniSrc: [],
  });



  const toggleCompass = () => {
    if (isCompass) {
      setIsCompass(false);
    } else {
      setIsCompass(true);
    }
  };

  const defOption = {
    title: {
      show: true,
      textStyle: {
        color: "#333",
        fontSize: 14,
        fontFamily: "Mulish",
        fontWeight: "400",
      },
      text: "Loading...",
      left: "center",
      top: "center",
    },
    xAxis: {
      show: false,
    },
    yAxis: {
      show: false,
      axisLabel: {
        width: 140,
        lineHeight: 10,
        overflow: "breakAll"
      },
    },
    series: [],
  };

  const [optionD, setOptionD] = useState(defOption);
  const [uCase, setUCase] = useState(null);

  const [url, setUrl] = useState("none");
  const [sector, setSector] = useState("");
  const [iuId, setIuId] = useState("");
  const [buttonType, setButtonType] = useState("");
  const [base64Data, setBase64Data] = useState(null);
  // const captureElement = useRef(null);


  const getBase64 = async (file) => {
    return new Promise((resolve) => {
      let fileInfo;
      let baseURL = "";
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        baseURL = reader.result;
        resolve(baseURL);
      };
    });
  };

  const [shareType, setShareType] = useState('fb');

  useEffect(() => {
    if (url !== "none") {
      if(shareType == 'fb') {
        fbShareButton.current?.click();
      } else if(shareType == 'ln') {
        lnShareButton.current?.click();
      } else {
        twShareButton.current?.click();
      }      
      setUrl("none");
    }
  }, [url, fbShareButton, lnShareButton, twShareButton]);

  const onClick = async (sType = 'fb') => {
    setShareType(sType);
    // Be sure to check for the "none" state, so we don't trigger an infinite loop.
    if (url === "none") {
      const newUrl = await handleCaptureImage();
      setUrl(newUrl);
    }
  }

  const handleCaptureImage = () => {
    return new Promise((resolve, reject) => {
      setLoader(true);

    

      $("div#og").css({ 'height': 'auto', 'padding': '10px', 'width': '100%' });
      $(".drsIndicators_img").hide();
      $("p.sub-category-text, div.mapSource").removeClass('indDD')
      $(".dsrBarchart_list").hide();
      $(".legends, .filter, .content_arrow ").hide();
      $(".drs_sources").hide();
  
      $(".multiple-value.drsChartss").css('flex-direction', 'column')
      $(".dsrChart .maps_source").css('position', 'unset')
      $(".dsrDropdown").addClass("dsrdropDownload")
      $(".legendsNumber.legendsChart").css({ 'bottom': '40px', 'left': '10px' });
      // mapSource-hide
  
      // $(".dropdown-toggle").hide();
  
      let node1 = document.getElementById("og");
      let node2 = document.getElementById("copy");
      let mapSource = document.getElementById("downloadchartds");
  
      mapSource.style.display = "block !important";
  
      node2.innerHTML = node1.innerHTML;
      node2.style.display = "block";
      // $(".copy .secInd").removeClass('indDD')
  
      let div = $(".downloadChartBG");
      div.css("background-color : white");
  
      domtoimage.toBlob(node1).then((blob) => {
        let file = [];
        let bfile = "";
        let path = "";
        getBase64(blob).then((result) => {
          file["base64"] = result;
          let b = file.base64;
          bfile = b.split(",").pop();
          const dt = Date.now();
          path = `SDG_${dt}.png` + ";" + bfile;
          let dataToSend = {
            image: path,
          };
          console.log(dataToSend, "doneasdfgh");

          adminService
          .httpPost("/data-import/resources/add-image", dataToSend)
          .then((res) => {
          //   setLoader(false);
          console.log(res, "response checknew");
            if (res.success == true) {
              resolve(constants.resourceImagePath + res.file);
              console.log(constants.resourceImagePath + res.file,"datat search")
              setUrl(constants.resourceImagePath + res.file)
              // $("#main_ind_viewsss").find("button").show();
              node2.style.display = "none";
            } else {
              reject(null);
              console.log("error")
              setUrl("none");
              node2.style.display = "none";
              // $("#main_ind_viewsss").find("button").show();
            }
          });
          // captureElement.current.removeChild(additionalContentElement);


        });
      })
      .catch((error) => {
        console.error("Error capturing image:", error);
      })
      .finally(()=> {
        $("p.sub-category-text,  div.mapSource").addClass('indDD')
        $(".dsrBarchart_list").show();
        $(".drsIndicators_img").show();
        $(".legends, .filter, .content_arrow ").show();
        $(".drs_sources").show();
        $(".multiple-value.drsChartss").css('flex-direction', '')
        $('.downloadchartds').css('display', 'block');
  
        $(".dsrChart .maps_source").css('position', 'absolute')
        $("div#og").css({ 'height': '100%', 'padding': '', 'width': '' });
        $(".dsrDropdown").removeClass("dsrdropDownload");
        $(".legendsNumber.legendsChart").css({ 'bottom': '20px', 'left': '0px' });
        node2.style.display = "none";

        setLoader(false);

      });

  
      // });
  
    })
  };

  useEffect(() => {
    let uc = getUseCase();
    setUCase(uc);
    // renderChart(uc, props.type);
  }, [dat, props.type]);

  useEffect(() => {
    data = props.data;
    setUni(data);
    let srcList = [];
    data.map((x) => {
      if (!srcList.includes(x.source)) {
        srcList.push(x.source);
      }
    });
    setSourceList(srcList);
    if (srcList?.length > 0) {
      setFlag(false);
      let a = JSON.parse(JSON.stringify(srcList));
      a.push('*');
      setSource(a);
      setShowAllSelected(true);
    }
    // setDat(data.filter(x => x.source == srcList[0]))
    setDat(data);
  }, [props.data])

  const setUni = (data) => {
    let inds = [];
    let newInds = [];
    let tperiods = {};
    // let areas = [];
    let src = {};

    for (let row of data) {
      if (
        !inds?.includes(row.indicator + " | " + row.unit + " | " + row.subgroup)
      ) {
        inds.push(row.indicator + " | " + row.unit + " | " + row.subgroup);
      }
      let x = newInds?.filter(y => (y.indicator == row.indicator && y.unit == row.unit && y.subgroup == row.subgroup));
      if (x?.length == 0) {
        newInds.push({
          indicator: row.indicator,
          unit: row.unit,
          subgroup: row.subgroup,
        });
        tperiods[row.indicator + "-" + row.unit + "-" + row.subgroup] = [];
      }
      if (!tperiods[row.indicator + "-" + row.unit + "-" + row.subgroup]?.includes(row.timeperiod)) {
        tperiods[row.indicator + "-" + row.unit + "-" + row.subgroup].push(row.timeperiod);
        src[row.indicator + "-" + row.unit + "-" + row.subgroup + '-' + row.timeperiod] = [];
      }
      if (!src[row.indicator + "-" + row.unit + "-" + row.subgroup + '-' + row.timeperiod]?.includes(row.source)) {
        src[row.indicator + "-" + row.unit + "-" + row.subgroup + '-' + row.timeperiod].push(row.source);
      }

    }

    setMapState({
      uniIndicators: inds,
      uniNewIndicators: newInds,
      uniTP: tperiods,
      uniSrc: src,
    });

  }

  useEffect(() => {
    console.log("Source 0", source);
    if (flag) {
      setDat(data.filter(x => source.includes(x.source)))
    }
  }, [source])

  useEffect(() => {
    if (props.type != "map") {
      // let image = document.getElementById("label");
      setLabel(false);
      // image.src = "assets/lib/images/home/label_on.svg";
    }
  }, [props.type]);

  const getUseCase = () => {

    let [ind, unit, subgroup, area, timeperiod] = ["", "", "", "", ""];
    let [cind, cunit, csubgroup, carea, ctimeperiod] = [0, 0, 0, 0, 0];
    let d = [];

    // let dis = [];
    // let forms = {};
    let inds = [];
    let newInds = [];
    let tperiods = {};
    let areas = [];
    let src = {};

    let dTemp = dat.sort((a, b) => {
      return a.timeperiod - b.timeperiod;
    })
    for (let row of dTemp) {

      
      if (ind == "") {
        ind = row.indicator;
        cind += 1;
      } else if (ind != row.indicator) {
        cind = cind <= 1 ? cind + 1 : cind;
      }

      if (unit == "") {
        unit = row.unit;
        cunit += 1;
      } else if (unit != row.unit) {
        cunit = cunit <= 1 ? cunit + 1 : cunit;
      }

      if (subgroup == "") {
        subgroup = row.subgroup;
        csubgroup += 1;
      } else if (subgroup != row.subgroup) {
        csubgroup = csubgroup <= 1 ? csubgroup + 1 : csubgroup;
      }

      if (area == "") {
        area = row.area_code;
        carea += 1;
      } else if (area != row.area_code) {
        carea = carea <= 1 ? carea + 1 : carea;
      }

      if (timeperiod == "") {
        timeperiod = row.timeperiod;
        ctimeperiod += 1;
      } else if (timeperiod != row.timeperiod) {
        ctimeperiod = ctimeperiod <= 1 ? ctimeperiod + 1 : ctimeperiod;
      }

      d.push({
        // disaster: row.disaster ? row.disaster : dataSearchResultLang?.["baseline-data"][this.props.lang],
        // stage: row.stage ? row.stage : dataSearchResultLang?.["baseline-data"][this.props.lang],
        area: row.area,
        area_code: row.area_code,
        area_level: row.area_level,
        parent_id: row.parent_id,
        indicator: row.indicator,
        unit: row.unit,
        subgroup: row.subgroup,
        timeperiod: row.timeperiod,
        value: row.datavalue,
        source: row.source,
      });

      let y = areas?.filter((a) => {
        return a.area_code == row.area_code;
      });
      if (y.length == 0) {
        areas.push({
          area_code: row.area_code,
          area: row.area,
        });
      }

      // if (!dis?.includes(row.disaster)) {
      //   dis.push(row.disaster);
      //   forms[row.disaster] = [];
      // }
      // if (!forms[row.disaster]?.includes(row.stage)) {
      //   forms[row.disaster].push(row.stage);
      //   newInds[row.disaster+'-'+row.stage] = [];
      // }
      if (
        !inds?.includes(row.indicator + " | " + row.unit + " | " + row.subgroup)
      ) {
        inds.push(row.indicator + " | " + row.unit + " | " + row.subgroup);
      }
      let x = newInds?.filter(y => (y.indicator == row.indicator && y.unit == row.unit && y.subgroup == row.subgroup));
      if (x?.length == 0) {
        newInds.push({
          indicator: row.indicator,
          unit: row.unit,
          subgroup: row.subgroup,
        });
        tperiods[row.indicator + "-" + row.unit + "-" + row.subgroup] = [];
      }
      if (!tperiods[row.indicator + "-" + row.unit + "-" + row.subgroup]?.includes(row.timeperiod)) {
        tperiods[row.indicator + "-" + row.unit + "-" + row.subgroup].push(row.timeperiod);
        src[row.indicator + "-" + row.unit + "-" + row.subgroup + '-' + row.timeperiod] = [];
      }
      if (!src[row.indicator + "-" + row.unit + "-" + row.subgroup + '-' + row.timeperiod]?.includes(row.source)) {
        src[row.indicator + "-" + row.unit + "-" + row.subgroup + '-' + row.timeperiod].push(row.source);
      }

    }
    // let image = document.getElementById("label");
    // image.src = "assets/lib/images/home/label_on.svg";
    setLabel(false);
    setSwap(false);
    setShowData(d);
    console.log("showdata", d);

    if(itFlag) {
      setIndicator(newInds?.[0]);
      setTimeperiod(tperiods?.[newInds?.[0]?.indicator
        + '-' + newInds?.[0]?.unit
        + '-' + newInds?.[0]?.subgroup]?.[0]);
    }
    setITFlag(true);
    // let s = src[
    //   newInds?.[0]?.indicator
    //   +'-'+newInds?.[0]?.unit
    //   +'-'+newInds?.[0]?.subgroup
    //   +'-'+tperiods?.[newInds?.[0]?.indicator
    //   +'-'+newInds?.[0]?.unit
    //   +'-'+newInds?.[0]?.subgroup]?.[0]];

    // s?.push('*');

    // if(dat.length == data.length) {
    //   //only the first time
    //   setMapState({
    //     uniIndicators: inds,
    //     uniNewIndicators: newInds,
    //     uniTP: tperiods,
    //     uniSrc: src,
    //   });
    //   setFlag(false);
    //   setSource(s?s:[]);
    // }


    if (cind && cunit && csubgroup && carea && ctimeperiod) {
      return useCaseMatrix[cind][cunit][csubgroup][carea][ctimeperiod];
    }
    return null;
  };

  const ChartlabelNev = () => {
    // let image = document.getElementById("label");

    // if (image.getAttribute("src") === "assets/lib/images/home/label_on.svg") {
    //   image.src = "assets/lib/images/home/label-off.svg";
    // } else {
    //   image.src = "assets/lib/images/home/label_on.svg";
    // }
    setLabel(!label);
    const chartInstance = echarts.getInstanceByDom(chart.current);
    if (chartInstance) {
      let option = optionD;
      let newSeries = [];
      option?.series?.forEach((seri) => {
        seri.label = {
          show: !seri.label.show,
          position: type == "treemap" ? "center" : "top",
          formatter: function (params) {
            let val = (+params.value).toLocaleString();
            if (type == "treemap") {
              return `${params.data.name} \n ${val}`;
            }
            return val;
          },
        };
        newSeries.push(seri);
      });
      option.series = newSeries;
      chartInstance.clear();
      setOptionD(option);
      chartInstance.setOption(option);
    }
  };

  const chartLegend = () => {
    setLgend(!lgend)
    const chartInstance = echarts.getInstanceByDom(chart.current);
   
    if (chartInstance) {
      let option = optionD;
      option.legend.show = !option.legend.show;
      chartInstance.clear();
      setOptionD(option);
      chartInstance.setOption(option);
    }
  };

  const renderChart = (useCase, type) => { //, swap = false
    // setSwap(swap);
    const renderInstance = echarts.getInstanceByDom(chart.current);
    if (renderInstance) {
      chartInstance = renderInstance;
    } else {
      chartInstance = echarts.init(chart.current);
    }
    setTitle(getTitle(useCase?.useCase, type));
    let optionData = getOptionData(useCase?.useCase, type, swap);
    setOptionD(optionData);
    $('.tooltip').hide();
    // let elem = chart.current?.getEchartsInstance();
    chartInstance.clear();
    chartInstance.setOption(optionData);
    // setSwap(false);
    chartInstance.on('mouseover','xAxis.category',function (params) {
        
      $('.tooltip').show();
      $('.tooltip').text(params.value);
      
      var left = 0;
      var top = 0;
      if(params.event.event.offsetX) {
       left = params.event.event.offsetX;
       top = params.event.event.offsetY;
      } else {
       var offset = $(this).parent.offset();
       left = params.event.event.layerX - offset.left;
       top = params.event.event.layerY - offset.top;
      }
      $( ".tooltip" ).css({
        "left" : left,
        "top" : top
      });
    });

    chartInstance.on('mouseout','xAxis.category',function (params) {
      $('.tooltip').hide();      
    });


  };

  // data.sort(function(a, b) {
  //   return new Date(a.tpArr) - new Date(b.tpArr);
  // });

  const downloadChart = () => {

    setLoader(true);
    console.log("this is sourcee--", source)

    $("div#og").css({ 'height': 'auto', 'padding': '10px', 'width': '100%' });
    $(".drsIndicators_img").hide();
    $(".dsrBarchart_list").hide();
    $(".legends, .filter, .content_arrow ").hide();
    $(".drs_sources .chartSource").hide();
    $(".drs_sources.chartSource").addClass('chartSourceDownload');
    $(".dsrChart .dsr_barchart").addClass('mapsSourceDownload');
    $(".mapSource-hide").addClass('d-block');
    $(".drs_sources.drs_sourcesMap").addClass('d-none')
    $(".multiple-value.drsChartss").css('flex-direction', 'column')
    $(".dsrChart .maps_source").css('position', 'unset')
    $(".dsrDropdown").addClass("dsrdropDownload")
    $(".legendsNumber.legendsChart").css({ 'bottom': '40px', 'left': '10px'});
    $(".newSource").addClass('d-block');
   

    let node1 = document.getElementById("og");
    let node2 = document.getElementById("copy");
    let mapSource = document.getElementById("downloadchartds");

    mapSource.style.display = "block !important";

    node2.innerHTML = node1.innerHTML;
    node2.style.display = "block";

    let div = $(".downloadChartBG");
    div.css("background-color : white");

    domtoimage.toBlob(node1).then((blob) => {
      saveFile(blob);
      $(".dsrBarchart_list").show();
      $(".drsIndicators_img").show();
      $(".legends, .filter, .content_arrow ").show();
      $(".drs_sources .chartSource").show();
      $(".drs_sources.drs_sourcesMap").addClass('d-block')
      $(".drs_sources.chartSource").removeClass('chartSourceDownload');
      $(".multiple-value.drsChartss").css('flex-direction', '')
      $('.downloadchartds').css('display', 'block');
      $(".mapSource-hide").removeClass('d-block');
      $(".dsrChart .maps_source").css('position', 'absolute')
      $("div#og").css({ 'height': '100%', 'padding': '', 'width': '' });
      $(".dsrDropdown").removeClass("dsrdropDownload");
      $(".legendsNumber.legendsChart").css({ 'bottom': '20px', 'left': '0px' });
      $(".dsrChart .dsr_barchart").removeClass('mapsSourceDownload');
      $(".newSource").removeClass('d-block');
      setLoader(false);

      // $(".dropdown-toggle").show();
      // $('.countryName').css('display', 'none');
      node2.style.display = "none";
    });
  };

  const saveFile = async (blob) => {
    const a = document.createElement("a");
    const dt = Date.now();
    a.download = `SDG_${title?.props?.children[0] ? title?.props?.children[0] : ''}_${getDate()}.png`;
    a.href = URL.createObjectURL(blob);
    a.click();
    setTimeout(() => URL.revokeObjectURL(a.href), 30 * 1000);
  };

  const getDate = () => {
    let d = new Date();
    let datestring = d.getDate() + "-" + (d.getMonth() + 1) + "-" + d.getFullYear() + " " +
      d.getHours() + ":" + d.getMinutes();
    return (datestring.replace(':', '.'))
  }


  const showLabel = () => {
    setLabel(!label);
  };
  const showLegend = () => {
    setLgend(!lgend);
  };

  useEffect(() => {
    renderChart(uCase, type);
  }, [swap]);

  useEffect(() => {
    if(type == 'map'){
      renderChart(uCase, type);
    }    
  }, [label]);

  const getTitle = (useCase, type) => {
    console.log("title and usecase-", useCase, type);
    let title = "";
    if (
      type == "line" ||
      type == "bar" ||
      type == "column" ||
      type == "funnel" ||
      type == "map"
    ) {
      switch (useCase) {
        case "UC1":
          title = (
            <>
              {showData?.[0]?.indicator} {" "}
              <span className="unit">|{" "}{showData?.[0]?.unit}</span>
              <span className="timeperiod">{" "}({showData?.[0]?.timeperiod})</span>
            </>
          );
          break;
        case "UC2":
          title = (
            <>
              {showData?.[0]?.area} - {showData?.[0]?.indicator}{" "}
              <span className="unit">|{" "}{showData?.[0]?.unit}</span>
            </>
          );
          break;

        case "UC3":
          title = (
            <>
              {showData?.[0]?.indicator} {" "}
              <span className="unit">|{" "}{showData?.[0]?.unit}</span>
              <span className="timeperiod">{" "}({showData?.[0]?.timeperiod})</span>
            </>
          );
          break;

        case "UC4":
          title = (
            <>
              {showData?.[0]?.indicator} {" "}
              <span className="unit">|{" "}{showData?.[0]?.unit}</span>
              <span className="subgroup">|{" "}{showData?.[0]?.subgroup}</span>
            </>
          );
          break;

        case "UC5":
          title = (
            <>
              {showData?.[0]?.area} - {showData?.[0]?.indicator} {" "}
              <span className="unit">|{" "}{showData?.[0]?.unit}</span>
              <span className="timeperiod">{" "}({showData?.[0]?.timeperiod})</span>
            </>
          );
          break;


        case "UC6":
          title = (
            <>
              {showData?.[0]?.indicator} {" "}
              <span className="unit">|{" "}{showData?.[0]?.unit}</span>
              <span className="timeperiod">{" "}({showData?.[0]?.timeperiod})</span>
            </>
          );
          break;

        case "UC7":
          title = (
            <>
              {showData?.[0]?.indicator}{" "} <span className="unit">|{" "}{showData?.[0]?.unit}</span>
            </>
          );
          break;

        case "UC8":
          title = (
            <>
              {showData?.[0]?.unit}{" "}
              <span className="subgroup">|{" "}{showData?.[0]?.subgroup}</span>
            </>
          );
          break;

        case "UC9":
          title = <>{showData?.[0]?.subgroup}</>
          break;

        case "UC10":
          title = "";
          break;

        case "UC11":
          title = (
            <>
              {showData?.[0]?.indicator} {" "}
              <span className="subgroup">|{" "}{showData?.[0]?.subgroup}</span>
            </>
          );
          break;

        case "UC12":
          title = (
            <>
              {showData?.[0]?.area} - {showData?.[0]?.indicator} {" "}
              <span className="subgroup">|{" "}{showData?.[0]?.subgroup}</span>
            </>
          );
          break;

        case "UC13":
          title = (
            <>
              {showData?.[0]?.indicator} {" "}
              <span className="subgroup">|{" "}{showData?.[0]?.subgroup}</span>
              <span className="timeperiod">{" "}({showData?.[0]?.timeperiod})</span>
            </>
          );
          break;

        case "UC14":
          title = (
            <>
              {showData?.[0]?.unit} {" "}
              <span className="subgroup">|{" "}{showData?.[0]?.subgroup}</span>
              <span className="timeperiod">{" "}({showData?.[0]?.timeperiod})</span>
            </>
          );
          break;

        case "UC15":
          title = (
            <>
              {showData?.[0]?.indicator}{" "}
              <span className="timeperiod">{" "}({showData?.[0]?.timeperiod})</span>
            </>
          );
          break;

        case "UC16":
          title = (
            <>
              {showData?.[0]?.subgroup}{" "}
              <span className="timeperiod">{" "}({showData?.[0]?.timeperiod})</span>
            </>
          );
          break;

        case "UC17":
          title = (
            <>
              {showData?.[0]?.area} - {showData?.[0]?.indicator}{" "}
              <span className="unit">|{" "}{showData?.[0]?.unit}</span>
            </>
          );
          break;

        case "UC18":
          title = (
            <>
              {showData?.[0]?.area} - {showData?.[0]?.unit}{" "}
              <span className="subgroup">|{" "}{showData?.[0]?.subgroup}</span>
            </>
          );
          break;

        case "UC19":
          title = (
            <>
              {showData?.[0]?.unit}{" "}
              <span className="subgroup">|{" "}{showData?.[0]?.subgroup}</span>
              <span className="timeperiod">{" "}({showData?.[0]?.timeperiod})</span>
            </>
          );
          break;

        case "UC20":
          title = (
            <>
              {showData?.[0]?.area} - {showData?.[0]?.unit}
              <span className="timeperiod">{" "}({showData?.[0]?.timeperiod})</span>
            </>
          );
          break;

        case "UC21":
          title = <>{showData?.[0]?.indicator}</>;
          break;

        case "UC22":
          title = (
            <>
              {showData?.[0].indicator}{" "}
              <span>|{" "}{showData?.[0].subgroup}</span>
              <span className="timeperiod">{" "}({showData?.[0].timeperiod})</span>
            </>
          );
          break;

        case "UC23":
          title = (
            <>
              {showData?.[0].area} - <span className="indicator">{showData?.[0].indicator}</span>
            </>
          );
          break;

        case "UC24":

          title = (
            <>
              {showData?.[0].indicator}
              <span className="timeperiod">{" "}({showData?.[0].timeperiod})</span>
            </>
          );
          break;

        case "UC25":
          title = (
            <>
              {showData?.[0].unit}
              <span className="timeperiod">{" "}({showData?.[0].timeperiod})</span>
            </>
          );
          break;

        case "UC26":
          title = <>{showData?.[0].unit}</>;
          break;

        case "UC27":
          title = (
            <>
              {showData?.[0].area} - <span className="unit">{showData?.[0].unit}</span>
            </>
          );
          break;

        case "UC28":
          title = (
            <>
              {showData?.[0].area} -{" "}
              <span className="subgroup">{showData?.[0].subgroup}</span>
            </>
          );
          break;

        case "UC29":
          title = (
            <>
              {showData?.[0].subgroup}
              <span className="timeperiod">{" "}({showData?.[0].timeperiod})</span>
            </>
          );
          break;

        case "UC30":
          title = <>{showData?.[0].timeperiod}</>;
          break;

        case "UC31":
          title = <>{showData?.[0].timeperiod}</>;
          break;

        case "UC32":
          title = <>{showData?.[0].area}</>;
          break;

      }
    } else if (
      type == "pie" ||
      type == "doughnut" ||
      type == "treemap" ||
      type == "radar" ||
      type == "map"
    ) {
      switch (useCase) {
        case "UC1":
          title = (
            <>
              {showData?.[0]?.indicator}{" "}
              <span className="unit"> |{" "}{showData?.[0]?.unit}</span>
              <span className="timeperiod">{" "}({showData?.[0]?.timeperiod})</span>
            </>
          );
          break;
        case "UC2":
          title = (
            <>
              {showData?.[0]?.indicator}{" "}
              <span className="unit"> |{" "}{showData?.[0]?.unit}</span> (
              <span className="subgroup">{showData?.[0]?.subgroup}</span>)
            </>
          );
          break;
        case "UC3":
          title = (
            <>
              {showData?.[0]?.indicator} {" "}
              <span className="unit">|{" "}{showData?.[0]?.unit}</span>
              <span className="subgroup">|{" "}{showData?.[0]?.subgroup}</span>
              <span className="timeperiod">{" "}({showData?.[0]?.timeperiod})</span>
            </>
          );
          break;

        case "UC4":
          title = (
            <>
              {showData?.[0]?.indicator}{" "}
              <span className="unit"> |{" "}{showData?.[0]?.unit}</span>
              <span className="subgroup">|{" "}{showData?.[0]?.subgroup}</span>
            </>
          );
          break;
        case "UC5":
          title = (
            <>
              {showData?.[0]?.area}{"-"}
              <span className=""> {showData?.[0]?.indicator}</span>
              <span className=""> |{" "}{showData?.[0]?.unit}</span>
            </>
          );

          break;
        case "UC6":
          title = "";
          // title = showData?.[0]?.disaster + "-" + showData?.[0]?.stage;
          break;
        case "UC7":
          title = (
            <>
              {showData?.[0]?.indicator} {" "}<span className="">|{" "}{showData?.[0]?.unit}</span>
            </>
          );
          break;
        case "UC8":
          title = (
            <>
              <span>{showData?.[0]?.unit}{" "}</span> <span className=""> |{" "}{showData?.[0]?.subgroup}</span>
            </>
          );
          break;
        case "UC9":
          title = (<span>{showData?.[0]?.subgroup}</span>);
          break;
        case "UC10":
          title = "";
          // title = showData?.[0]?.disaster + "-" + showData?.[0]?.stage;

          break;
        case "UC11":
          title = (
            <>
              {showData?.[0]?.indicator}{" "}<span className=""> |{" "}{showData?.[0]?.subgroup}</span>
            </>
          );
          break;
        case "UC12":
          title = (

            <>
              {showData?.[0]?.area} - {showData?.[0]?.indicator}
              <span className="subgroup"> |{" "}{showData?.[0]?.subgroup}</span>
            </>
          );
          break;


        case "UC13":
          title = (
            <>
              {showData?.[0]?.indicator}{" "}

              <span className=""> |{" "}{showData?.[0]?.subgroup}</span>

              <span className=""> {" "}({showData?.[0]?.timeperiod})</span>

            </>
          );
          break;
        case "UC14":
          title = (
            <>

              {showData?.[0]?.area} {" - "}
              <span className=""> {showData?.[0]?.unit}</span> {" "}

              <span> |{" "}{showData?.[0]?.subgroup}</span>

              <span>{" "}({showData?.[0]?.timeperiod})</span>


            </>

          );

          break;
        case "UC15":

          title = (
            <>
              {showData?.[0]?.area} {" - "}
              <span className="">{showData?.[0]?.indicator}</span>
              <span className="">{" "}({showData?.[0]?.timeperiod})</span>
            </>
          );
          break;
        case "UC16":

          title = (
            <>
              {showData?.[0]?.area} {" - "}
              <span className="">{showData?.[0]?.subgroup}</span>
              <span className="">{" "}({showData?.[0]?.timeperiod})</span>
            </>
          );
          break;
        case "UC17":
          title = (
            <>
              {showData?.[0]?.area} {" - "}
              <span className="">{showData?.[0]?.unit}</span>{" "}
              <span className=""> |{" "}{showData?.[0]?.indicator}</span>
            </>
          );
          break;
        case "UC18":
          title = (
            <>
              {showData?.[0]?.area} {" - "}
              <span className="">{showData?.[0]?.unit}</span>{" "}
              <span className=""> |{" "}{showData?.[0]?.subgroup}</span>

            </>

          );

          break;
        case "UC19":
          title =
            (
              <>
                {showData?.[0]?.unit}{" "}
                <span className=""> |{" "}{showData?.[0]?.subgroup}</span>
                <span className="">{" "}({showData?.[0]?.timeperiod})</span>
              </>
            );
          break;
        case "UC20":
          title =
            (
              <>
                {showData?.[0]?.area} {" - "}
                <span className="">{showData?.[0]?.unit}</span>
                <span className="">{" "}({showData?.[0]?.timeperiod})</span>

              </>
            );
          break;
        case "UC21":
          title = showData?.[0]?.indicator;
          break;
        case "UC22":
          title = (

            <>
              {showData?.[0]?.indicator}{" "}
              <span className=""> |{" "}{showData?.[0]?.subgroup}</span>

              <span className="">{" "}({showData?.[0]?.timeperiod})</span>


            </>
          );

          break;
        case "UC23":
          title = (
            <>
              {showData?.[0]?.area} {" - "}
              <span>{showData?.[0]?.indicator}</span>
            </>
          );
          break;
        case "UC24":
          title = (
            <>
              <span>{showData?.[0]?.indicator}</span>
              <span>{" "}({showData?.[0]?.timeperiod})</span>
            </>
          );
          break;
        case "UC25":
          title = (
            <>
              <span>{showData?.[0]?.unit}</span>
              <span>{" "}({showData?.[0]?.timeperiod})</span>
            </>
          );
          break;
        case "UC26":
          title = showData?.[0]?.unit;
          break;
        case "UC27":
          title = (
            <>
              {showData?.[0]?.area} {" - "}
              <span>{showData?.[0]?.unit}</span>
            </>
          );
          break;
        case "UC28":
          title = (
            <>
              {showData?.[0]?.area} {" - "}
              <span>{showData?.[0]?.subgroup}</span>
            </>
          );
          break;

        case "UC29":
          title = (
            <>
              <span>{showData?.[0]?.subgroup}</span>
              <span>{" "}({showData?.[0]?.timeperiod})</span>
            </>
          );
          break;
        case "UC30":
          title =
            (
              <>
                {showData?.[0]?.area}
                <span>{" "}({showData?.[0]?.timeperiod})</span>
              </>
            );
          break;
        case "UC31":
          title = showData?.[0]?.timeperiod;
          break;
        case "UC32":
          title = showData?.[0]?.area;
          break;
      }
    }

    // title =
    //   showData?.[0]?.disaster +
    //   (showData?.[0]?.disaster != "" ? "-" : "") +
    //   showData?.[0]?.stage +
    //   (showData?.[0]?.stage != "" && title != "" ? "-" : "") +
    //   title;

    return title;
  };


  const getOptionData = (useCase, type, swap) => {
    
    let labelData = label;

    let oData = {
      title: {
        show: true,
        textStyle: {
          color: "#333",
          fontSize: 14,
          fontFamily: "Mulish",
          fontWeight: "400",
        },
        // text: "No Data",
        text: `${dataSearchResultLang.noData[lang]}`,
        left: "center",
        top: "center",
      },
      legend: {
        orient: 'horizontal',
        right: 200,
        top: 'center',
        show: lgend
      },
      xAxis: {
        show: false,
      },
      yAxis: {
        show: false,
        axisLabel: {
          width: 140,
          lineHeight: 10,
          overflow: "breakAll"
        },
      },
      series: [],
      source: "",
    };

    if (type == "map") {
      let dataToShow = showData?.filter(
        (x) =>
          indicator?.indicator == x?.indicator &&
          indicator?.unit == x?.unit &&
          indicator?.subgroup == x?.subgroup &&
          x?.timeperiod == timeperiod &&
          source.includes(x.source)
      );

      let dataMap = [];
      let nameMap = {};
      let min = 0;
      let max = 0;
      let minLevel = 5;
      let maxLevel = 0;
      for (let i = 0; i < dataToShow?.length; i++) {
        if (!Object.keys(nameMap).includes(dataToShow[i].area_code)) {
          if (minLevel > dataToShow[i].area_level) {
            minLevel = dataToShow[i].area_level;
          }
          if (maxLevel < dataToShow[i].area_level) {
            maxLevel = dataToShow[i].area_level;
          }
          dataMap.push({
            value: +dataToShow[i].value,
            name: dataToShow[i].area,
            code: dataToShow[i].area_code,
            level: dataToShow[i].area_level,
            // parent_id: dataToShow[i].parent_id,
          });
          nameMap[dataToShow[i].area_code] = dataToShow[i].area;
          if (max < +dataToShow[i].value) {
            max = +dataToShow[i].value;
          }
          if (min > +dataToShow[i].value) {
            min = +dataToShow[i].value;
          }
        }
      }

      if (dataMap?.length == 0) {
        setNoData(true);
        return oData;
      }
      setNoData(false);
      // if(minLevel == 1 && maxLevel == 1) {
      //   return {
      //     title: {
      //       show: true,
      //       textStyle: {
      //         color: "#333",
      //         fontSize: 14,
      //         fontFamily: "Mulish",
      //         fontWeight: "400",
      //       },
      //       text: "Please select sub-national areas to view map",
      //       left: "center",
      //       top: "center",
      //     },
      //     xAxis: {
      //       show: false,
      //     },
      //     yAxis: {
      //       show: false,
      //     },
      //     series: [],
      //     source: "",
      //   };
      // }

      let d = getLegendData(dataMap);

      let geoJSONData = null;
      let newCoords = [];
      geoJSONData = JSON.parse(JSON.stringify(geoJSONData2));
      // if (minLevel < 3) {
      //   geoJSONData = JSON.parse(JSON.stringify(geoJSONData2));

      //   let smallerregions3 = dataMap?.filter((x) => x.level == 3);
      //   smallerregions3.map((item) => {
      //     let x = geoJSONData3?.features?.filter((geo) => {
      //       return item.code === geo?.properties?.["ID_"];
      //     });
      //     x.map((geo) => {
      //       newCoords.push(geo);
      //     });
      //   });
      //   let smallerregions4 = dataMap?.filter((x) => x.level == 4);
      //   smallerregions4.map((item) => {
      //     let x = geoJSONData4?.features?.filter((geo) => {
      //       return item.code === geo?.properties?.["ID_"];
      //     });
      //     x.map((geo) => {
      //       newCoords.push(geo);
      //     });
      //   });
      //   geoJSONData.features.push(...newCoords);
      // } else {
      //   // let newCoords = [];

      //   dataMap?.map((item) => {
      //     let x = null;
      //     if (item.level == 3) {
      //       x = geoJSONData3?.features?.filter((geo) => {
      //         return item.code === geo?.properties?.["ID_"];
      //       });
      //     } else {
      //       x = geoJSONData4?.features?.filter((geo) => {
      //         return item.code === geo?.properties?.["ID_"];
      //       });
      //     }
      //     x.map((geo) => {
      //       newCoords.push(geo);
      //     });
      //   });
      //   if (newCoords?.length == 0) {
      //     return oData;
      //   }
      //   geoJSONData = { type: "FeatureCollection", features: newCoords };
      // }

      echarts.registerMap("TTO", geoJSONData);

      return {
        // title: {
        //   text: title,
        // },
        tooltip: {
          trigger: "item",
          formatter: function (params) {
            return (
              params.name +
              "\n" +
              (isNaN(params.value) ? " " : params.value)
            );
          },
        },
        visualMap: {
          show: true,
          min: min,
          max: max,
          pieces: d.legends?.length > 0 ? d.legends : [{ "color": "#e2e2e2", "label": "No Data", "max": 0, "min": 0 }],
          orient: "vertical",
          showLabel: true,
          showLegend: true,
          inverse: true,
          text: [indicator.unit],
          textStyle: {
            color: "#333",
            fontSize: 12,
          },
          formatter: legendFormatter,
        },
        // geo: {
        //   map: "TTO",
        //   regions: [
        //     {
        //       name: "North Pole",
        //       itemStyle: {
        //         normal: {
        //           areaColor: "#ff0000", // Adjust the fill color of the North Pole symbol
        //         },
        //       },
        //       label: {
        //         show: true,
        //         position: "insideBottom",
        //         distance: 10,
        //         color: "#ffffff", // Adjust the label color of the North Pole symbol
        //       },
        //       value: 1,
        //     },
        //   ],
        // },
        series: [
          {
            name: "Trinidad and Tobago",
            type: "map",
            map: "TTO",
            zoom: zoomData,
            label: {
              show: labelData,
              formatter: function (params) {
                return params.name + '\n' + (isNaN(params.value) ? '' : params.value);
              },
            },
            emphasis: {
              disabled: true,
              // label: {
              //   show: false,
              // },
              // itemStyle: {
              //   areaColor: "none",
              // },
            },
            select: {
              disabled: true
            },
            data: dataMap,
            nameMap: nameMap,
            // title:showData?.[0]?.unit
          },
        ],
      };
    }

    if (useCase == "UC1") {
      oData = {
        title: {
          show: true,
          textStyle: {
            color: "#333", //'#B8372B',
            fontSize: 50,
            fontFamily: "Mulish",
            fontWeight: "400",
          },
          text: (+showData?.[0]?.value).toLocaleString(), //(+result.data?.[0]?.new_value)?.toLocaleString(),
          left: "center",
          top: "center",
        },
        xAxis: {
          show: false,
        },
        yAxis: {
          show: false,
          axisLabel: {
            width: 140,
            lineHeight: 10,
            overflow: "breakAll"
          },
        },
        series: [],
        source: "",
      };
      return oData;
    }

    if (type == "line" || type == "bar" || type == "funnel") {
      if (useCase == "UC2" || useCase == "UC12") {
        //TP(multiple) on x-axis and Subgroup on Y-axis
        let tpArr = [];
        let vData = {};
        let d = {};
        let sgNames = [];
        
        if (swap) {
          showData.forEach((row) => {
            let sgName = row.timeperiod;

            let tp = row.subgroup;
            if (useCase == "UC12") {
              tp = row.unit;
            }

            if (!tpArr.includes(tp)) {
              tpArr.push(tp);
            }

            if (!sgNames.includes(sgName)) {
              sgNames.push(sgName);
            }

            if (!(tp in d)) {
              d[tp] = {};
            }
            d[tp][sgName] = row.value;
          });
        } else {
          showData.forEach((row) => {
            let tp = row.timeperiod;

            let sgName = row.subgroup;
            if (useCase == "UC12") {
              sgName = row.unit;
            }
            if (!sgNames.includes(sgName)) {
              sgNames.push(sgName);
            }

            if (!tpArr.includes(tp)) {
              tpArr.push(tp);
            }
            if (!(tp in d)) {
              d[tp] = {};
            }
            d[tp][sgName] = row.value;
          });
        }

        for (let t of tpArr) {
          for (let sg of sgNames) {
            if (sg in vData) {
              vData[sg].push(d[t][sg]);
            } else {
              vData[sg] = [d[t][sg]];
            }
          }
        }

        let seri = [];
        const startColorIndex = colorPalette.length - sgNames.length;


        if (type == "line" || type == "bar") {
          sgNames.forEach((sg, i) => {
            const currentColor = colorPalette[startColorIndex + i] || colorPalette[i % colorPalette.length];
            seri.push({
              name: sg,
              data: vData[sg],
              type: type,
              colorBy: "data",
              label: {
                show: false,
                position: "top",
                formatter: function (params) {
                  return (+params.value).toLocaleString();
                },
              },
              emphasis: {
                focus: "series",
              },
              lineStyle: {
                color: "#A6170A",
                //color: this.colors[i],
                width: 1,
              },
              itemStyle: {
                color: currentColor,
                borderColor: currentColor,
              },
            });
          });

          oData = {
            tooltip: {
              trigger: "item",
              axisPointer: {
                type: "cross",
              },
            },
            legend: {
              data: sgNames,
              orient: "vertical",
              top: "5%",
              // icon: 'rect',
              right: 0,
              bottom: 0,
              // height: 'auto',
              itemGap: 14,
              type: "scroll",
              show: lgend,
              formatter: function (name) {
                return name.length > 17 ? name.substring(0, 17) + "..." : name;
              },
              tooltip: {
                show: true,
                trigger: "item",
              },
              textStyle: {
                color: "#333",
              },
            },
            grid: {
              containLabel: true,
              left: "0%",
              right: "18%",
              // height: 'auto',
              // bottom: '3%',
              top: "10%",
              y2: 30,
            },
            xAxis: {
              type: "category",  
              triggerEvent: true,
              data: tpArr,
              axisLabel: {
                color: "#333",
                width: 140,
                lineHeight: 14,
                overflow: "truncate",
                rotate: -40,
                interval: 0
              },
              axisLine: {
                lineStyle: {
                  color: "#333",
                },
              },
            },
            yAxis: {
              type: "value",
              axisLabel: {
                color: "#333",
                  width: 140,
                  lineHeight: 10,
                  overflow: "breakAll"
              },
              splitLine: {
                lineStyle: {
                  color: "#333",
                  type: "dashed",
                },
              },
            },
            toolbox: {
              show: false,
              orient: "vertical",
              left: "right",
              top: "center",
              feature: {
                mark: { show: true },
                dataView: { show: true, readOnly: true },
                magicType: { show: true, type: ["bar", "line"] },
                // restore: { show: true },
                saveAsImage: { show: true, title: "Download" },
              },
            },
            series: seri,
          };
        } else if (type == "funnel") {
          sgNames.forEach((sg, i) => {
            seri.push({
              name: sg,
              data: vData[sg],
              type: type,
              left: "10%",
              top: 60,
              bottom: 60,
              width: "80%",
              // min: 0,
              // max: 100,
              minSize: "0%",
              maxSize: "100%",
              sort: "ascending",
              gap: 2,
              label: {
                show: false,
                position: "inside",
                formatter: function (params) {
                  return (+params.value).toLocaleString();
                },
              },
              emphasis: {
                focus: "series",
              },
              lineStyle: {
                color: "#A6170A",
                //color: this.colors[i],
                width: 1,
              },
              itemStyle: {
                borderWidth: 1,
                borderColor: "#A6170A",
                color: "#A6170A",
                //borderColor: this.colors[i],
                //color: this.colors[i]
              },
            });
          });

          oData = {
            tooltip: {
              trigger: "item",
              axisPointer: {
                type: "cross",
              },
            },
            legend: {
              data: sgNames,
              // orient: 'vertical',
              // top: 'center',
              // icon: 'rect',
              // right: 0,
              bottom: 0,
              // height: 'auto',
              type: "scroll",
              show: lgend,
              formatter: function (name) {
                return name.length > 17 ? name.substring(0, 17) + "..." : name;
              },
              tooltip: {
                show: true,
                trigger: "item",
              },
              textStyle: {
                color: "#333",
              },
            },
            grid: {
              containLabel: true,
              left: "10%",
              // height: 'auto',
              // bottom: '3%',
              top: "10%",
              y2: 30,
            },
            series: seri,
          };
        }
      } else if (
        useCase == "UC3" ||
        useCase == "UC7" ||
        useCase == "UC8" ||
        useCase == "UC9" ||
        useCase == "UC10" ||
        useCase == "UC11" ||
        useCase == "UC13"
      ) {
        //Area(multiple) on x-axis and others on Y-axis
        let tpArr = [];
        let vData = {};
        let d = {};
        let sgNames = [];
        // let colorPalette = ["#B8372B", "#CF655B", "#ED9C94", "#FFCBC6"].reverse();

        if (swap) {
          showData.forEach((row) => {
            let sgName = row.area;
            if (useCase != "UC3" && useCase != "UC13") {
              sgName = sgName + "-" + row.timeperiod;
            }

            let tp;
            if (useCase == "UC8") {
              tp = row.indicator;
            } else if (useCase == "UC9") {
              tp = row.indicator + "-" + row.unit;
            } else if (useCase == "UC10") {
              tp = row.indicator + "-" + row.unit + "-" + row.subgroup;
            } else if (useCase == "UC11" || useCase == "UC13") {
              tp = row.unit;
            } else {
              tp = row.subgroup;
            }

            if (!sgNames.includes(sgName)) {
              sgNames.push(sgName);
            }

            if (!tpArr.includes(tp)) {
              tpArr.push(tp);
            }

            if (!(tp in d)) {
              d[tp] = {};
            }
            d[tp][sgName] = row.value;
          });
        } else {
          console.log("Sudhanshu showData ", showData.filter(x => x.subgroup != null))
          showData.forEach((row) => {
            let tp = row.area;
            if (useCase != "UC3" && useCase != "UC13") {
              tp = tp + "-" + row.timeperiod;
            }

            let sgName;
            if (useCase == "UC8") {
              sgName = row.indicator;
            } else if (useCase == "UC9") {
              sgName = row.indicator + "-" + row.unit;
            } else if (useCase == "UC10") {
              sgName = row.indicator + "-" + row.unit + "-" + row.subgroup;
            } else if (useCase == "UC11" || useCase == "UC13") {
              sgName = row.unit;
            } else {
              sgName = row.subgroup;
            }

            if (!sgNames.includes(sgName)) {
              sgNames.push(sgName);
            }

            if (!tpArr.includes(tp)) {
              tpArr.push(tp);
            }

            if (!(tp in d)) {
              d[tp] = {};
            }
            d[tp][sgName] = row.value;
          });
        }

        for (let t of tpArr) {
          for (let sg of sgNames) {
            if (sg in vData) {
              vData[sg].push(d[t][sg]);
            } else {
              vData[sg] = [d[t][sg]];
            }
          }
        }

        let seri = [];
        const startColorIndex = colorPalette.length - sgNames.length;


        if (type == "line" || type == "bar") {
          sgNames.forEach((sg, i) => {
            const currentColor = colorPalette[startColorIndex + i] || colorPalette[i % colorPalette.length];
            seri.push({
              name: sg,
              data: vData[sg],
              type: type,
              colorBy: "data",
              label: {
                show: false,
                position: "top",
                formatter: function (params) {
                  return (+params.value).toLocaleString();
                },
              },
              emphasis: {
                focus: "series",
              },
              lineStyle: {
                color: "#A6170A",
                //color: this.colors[i],
                width: 1,
              },
              itemStyle: {
                color: currentColor,
                borderColor: currentColor,
              },
            });
          });

          console.log("Sudhanshu sgNames ", sgNames)

          oData = {
            tooltip: {
              trigger: "item",
              axisPointer: {
                type: "cross",
              },
            },
            legend: {
              data: sgNames,
              orient: "vertical",
              top: "5%",
              // icon: 'rect',
              right: 0,
              bottom: 0,
              // height: 'auto',
              itemGap: 14,
              type: "scroll",
              show: lgend,
              formatter: function (name) {
                console.log("Sudhanshu name ", name)
                return name.length > 17 ? name.substring(0, 17) + "..." : name;
              },
              tooltip: {
                show: true,
                trigger: "item",
              },
              textStyle: {
                color: "#333",
              },
            },
            grid: {
              containLabel: true,
              left: "0%",
              right: "18%",
              // height: 'auto',
              // bottom: '3%',
              top: "10%",
              y2: 30,
            },
            xAxis: {
              type: "category",  
              triggerEvent: true,
              data: tpArr,
              axisLabel: {
                color: "#333",
                width: 140,
                lineHeight: 14,
                overflow: "truncate",
                rotate: -40,
                interval: 0
              },
              axisLine: {
                lineStyle: {
                  color: "#333",
                },
              },
            },
            yAxis: {
              type: "value",
              axisLabel: {
                color: "#333",
                  width: 140,
                  lineHeight: 10,
                  overflow: "breakAll"
              },
              splitLine: {
                lineStyle: {
                  color: "#333",
                  type: "dashed",
                },
              },
            },
            toolbox: {
              show: false,
              orient: "vertical",
              left: "right",
              top: "center",
              feature: {
                mark: { show: true },
                dataView: { show: true, readOnly: true },
                magicType: { show: true, type: ["bar", "line"] },
                // restore: { show: true },
                saveAsImage: { show: true, title: "Download" },
              },
            },
            series: seri,
          };
        } else if (type == "funnel") {
          sgNames.forEach((sg, i) => {
            seri.push({
              name: sg,
              data: vData[sg],
              type: type,
              left: "10%",
              top: 60,
              bottom: 60,
              width: "80%",
              // min: 0,
              // max: 100,
              minSize: "0%",
              maxSize: "100%",
              sort: "ascending",
              gap: 2,
              label: {
                show: false,
                position: "inside",
                formatter: function (params) {
                  return (+params.value).toLocaleString();
                },
              },
              emphasis: {
                focus: "series",
              },
              lineStyle: {
                color: "#A6170A",
                //color: this.colors[i],
                width: 1,
              },
              itemStyle: {
                borderWidth: 1,
                borderColor: "#A6170A",
                color: "#A6170A",
                //borderColor: this.colors[i],
                //color: this.colors[i]
              },
            });
          });

          oData = {
            tooltip: {
              trigger: "item",
              axisPointer: {
                type: "cross",
              },
            },
            legend: {
              data: sgNames,
              // orient: 'vertical',
              // top: 'center',
              // icon: 'rect',
              // right: 0,
              bottom: 0,
              // height: 'auto',
              type: "scroll",
              show: lgend,
              formatter: function (name) {
                return name.length > 17 ? name.substring(0, 17) + "..." : name;
              },
              tooltip: {
                show: true,
                trigger: "item",
              },
              textStyle: {
                color: "#333",
              },
            },
            grid: {
              containLabel: true,
              left: "10%",
              // height: 'auto',
              // bottom: '3%',
              top: "10%",
              y2: 30,
            },
            series: seri,
          };
        }
      } else if (useCase == "UC4" || useCase == "UC5") {
        //TP(multiple) on x-axis and Area on Y-axis
        let tpArr = [];
        let vData = {};
        let d = {};
        let sgNames = [];
        // let colorPalette = ["#B8372B", "#CF655B", "#ED9C94", "#FFCBC6"].reverse();

        if (swap) {
          showData.forEach((row) => {
            let sgName = row.timeperiod;

            let tp = row.area;
            if (useCase == 'UC5') {
              sgName = row.subgroup;
            }
            if (!sgNames.includes(sgName)) {
              sgNames.push(sgName);
            }

            if (!tpArr.includes(tp)) {
              tpArr.push(tp);
            }
            if (!(tp in d)) {
              d[tp] = {};
            }
            d[tp][sgName] = row.value;
          });
        } else {
          showData.forEach((row) => {
            let tp = row.timeperiod;

            let sgName = row.area;
            if (useCase == 'UC5') {
              tp = row.subgroup;
            }

            if (!sgNames.includes(sgName)) {
              sgNames.push(sgName);
            }

            if (!tpArr.includes(tp)) {
              tpArr.push(tp);
            }
            if (!(tp in d)) {
              d[tp] = {};
            }
            d[tp][sgName] = row.value;
          });
        }

        for (let t of tpArr) {
          for (let sg of sgNames) {
            if (sg in vData) {
              vData[sg].push(d[t][sg]);
            } else {
              vData[sg] = [d[t][sg]];
            }
          }
        }

        let seri = [];
        const startColorIndex = colorPalette.length - sgNames.length;

        
        if (type == "line" || type == "bar") {
          sgNames.forEach((sg, i) => {
            const currentColor = colorPalette[startColorIndex + i] || colorPalette[i % colorPalette.length];

            seri.push({
              name: sg,
              data: vData[sg],
              colorBy: "data",
              type: type,
              label: {
                show: false,
                position: "top",
                formatter: function (params) {
                  return (+params.value).toLocaleString();
                },
              },
              emphasis: {
                focus: "series",
              },
              lineStyle: {
                color: "#A6170A",
                //color: this.colors[i],
                width: 1,
              },
              itemStyle: {
                color: currentColor,
                borderColor: currentColor,
              },
            });
          });

          oData = {
            tooltip: {
              trigger: "item",
              axisPointer: {
                type: "cross",
              },
            },
            legend: {
              data: sgNames,
              orient: "vertical",
              top: "5%",
              // icon: 'rect',
              right: 0,
              bottom: 0,
              // height: 'auto',
              itemGap: 14,
              type: "scroll",
              show: lgend,
              formatter: function (name) {
                return name.length > 17 ? name.substring(0, 17) + "..." : name;
              },
              tooltip: {
                show: true,
                trigger: "item",
              },
              textStyle: {
                color: "#333",
              },
            },
            grid: {
              containLabel: true,
              left: "0%",
              right: "18%",
              // height: 'auto',
              // bottom: '3%',
              top: "10%",
              y2: 30,
            },
            xAxis: {
              type: "category",  
              triggerEvent: true,
              data: tpArr,
              axisLabel: {
                color: "#333",
                width: 140,
                lineHeight: 14,
                overflow: "truncate",
                rotate: -40,
                interval: 0
              },
              axisLine: {
                lineStyle: {
                  color: "#333",
                },
              },
            },
            yAxis: {
              type: "value",
              axisLabel: {
                color: "#333",
                  width: 140,
                  lineHeight: 10,
                  overflow: "breakAll"
              },
              splitLine: {
                lineStyle: {
                  color: "#333",
                  type: "dashed",
                },
              },
            },
            toolbox: {
              show: false,
              orient: "vertical",
              left: "right",
              top: "center",
              feature: {
                mark: { show: true },
                dataView: { show: true, readOnly: true },
                magicType: { show: true, type: ["bar", "line"] },
                // restore: { show: true },
                saveAsImage: { show: true, title: "Download" },
              },
            },
            series: seri,
          };
        } else if (type == "funnel") {
          sgNames.forEach((sg, i) => {
            seri.push({
              name: sg,
              data: vData[sg],
              type: type,
              left: "10%",
              top: 60,
              bottom: 60,
              width: "80%",
              // min: 0,
              // max: 100,
              minSize: "0%",
              maxSize: "100%",
              sort: "ascending",
              gap: 2,
              label: {
                show: false,
                position: "inside",
                formatter: function (params) {
                  return (+params.value).toLocaleString();
                },
              },
              emphasis: {
                focus: "series",
              },
              lineStyle: {
                color: "#A6170A",
                //color: this.colors[i],
                width: 1,
              },
              itemStyle: {
                borderWidth: 1,
                borderColor: "#A6170A",
                color: "#A6170A",
                //borderColor: this.colors[i],
                //color: this.colors[i]
              },
            });
          });

          oData = {
            tooltip: {
              trigger: "item",
              axisPointer: {
                type: "cross",
              },
            },
            legend: {
              data: sgNames,
              // orient: 'vertical',
              // top: 'center',
              // icon: 'rect',
              // right: 0,
              bottom: 0,
              // height: 'auto',
              type: "scroll",
              show: lgend,
              formatter: function (name) {
                return name.length > 17 ? name.substring(0, 17) + "..." : name;
              },
              tooltip: {
                show: true,
                trigger: "item",
              },
              textStyle: {
                color: "#333",
              },
            },
            grid: {
              containLabel: true,
              left: "10%",
              // height: 'auto',
              // bottom: '3%',
              top: "10%",
              y2: 30,
            },
            series: seri,
          };
        }
      }
      // else if (useCase == "UC5") {
      //   //if subgroup is multiple and on x-axis and value on y-axis
      //   let sgArr = [];
      //   let vData = [];
      //   let legendData = [];
      //   let colorPalette = [
      //     "#A6170A",
      //     "#ED9C94",
      //     "#CF655B",
      //     "#B8372B",
      //     "#7D1B12",
      //     "#440A05",
      //   ];
      //   //let tpName = "";
      //   if (swap) {
      //     showData.forEach((row) => {
      //       sgArr.push(row.value);
      //       vData.push(row.subgroup);
      //     });
      //   } else {
      //     showData.forEach((row) => {
      //       sgArr.push(row.subgroup);
      //       vData.push(row.value);
      //     });
      //   }

      //   if (type == "line" || type == "bar") {
      //     oData = {
      //       legend: {
      //         orient: "vertical",
      //         top: "5%",
      //         right: 0,
      //         bottom: 0,
      //         itemGap: 14,
      //         type: "scroll",
      //         formatter: function (name) {
      //           return name.length > 17 ? name.substring(0, 17) + "..." : name;
      //         },
      //         show: false,
      //         textStyle: {
      //           color: "#333",
      //         },
      //       },
      //       tooltip: {
      //         trigger: "item",
      //         axisPointer: {
      //           type: "cross",
      //         },
      //       },
      //       grid: {
      //         containLabel: true,
      //         left: "0%",
      //         right: "18%",
      //         // bottom: "3%",
      //         top: "10%",
      //         y2: 30,
      //       },
      //       xAxis: [
      //         {
      //           type: "category",
      //           data: sgArr,
      //           axisLabel: {
      //             color: "#333",
      //             width: 140,
      //             lineHeight: 14,
      //             overflow: "truncate",
      //             rotate: -40,
      //             interval: 0
      //           },
      //           axisLine: {
      //             lineStyle: {
      //               color: "#333",
      //             },
      //           },
      //         },
      //       ],
      //       yAxis: [
      //         {
      //           type: "value",
      //           axisLabel: {
      //             color: "#333",
      //           },
      //           splitLine: {
      //             lineStyle: {
      //               color: "rgba(255, 255, 255, 0.7)",
      //               type: "dashed",
      //             },
      //           },
      //         },
      //       ],
      //       series: [
      //         {
      //           name: "Value",
      //           data: vData,
      //           colorBy: "data",
      //           type: type,
      //           label: {
      //             show: false,
      //             position: "top",
      //             formatter: function (params) {
      //               return (+params.value).toLocaleString();
      //             },
      //           },
      //           emphasis: {
      //             focus: "series",
      //           },
      //           lineStyle: {
      //             color: "#A6170A",
      //             width: 1,
      //           },
      //           itemStyle: {
      //             color: function (params) {
      //               var dataIndex = params.dataIndex;
      //               return colorPalette[dataIndex % colorPalette.length];
      //             },
      //             // borderColor: colorPalette[i]
      //           },
      //         },
      //       ],
      //     };
      //   } else if (type == "funnel") {
      //     oData = {
      //       tooltip: {
      //         trigger: "item",
      //         axisPointer: {
      //           type: "cross",
      //         },
      //       },
      //       legend: {
      //         data: sgArr,
      //         // orient: 'vertical',
      //         // top: 'center',
      //         // icon: 'rect',
      //         // right: 0,
      //         bottom: 0,
      //         // height: 'auto',
      //         type: "scroll",
      //         show: true,
      //         formatter: function (name) {
      //           return name.length > 17 ? name.substring(0, 17) + "..." : name;
      //         },
      //         tooltip: {
      //           show: true,
      //           trigger: "item",
      //         },
      //         textStyle: {
      //           color: "#333",
      //         },
      //       },
      //       grid: {
      //         containLabel: true,
      //         left: "10%",
      //         // height: 'auto',
      //         // bottom: '3%',
      //         top: "10%",
      //         y2: 30,
      //       },
      //       series: [
      //         {
      //           name: "Value",
      //           data: vData,
      //           type: type,
      //           left: "10%",
      //           top: 60,
      //           bottom: 60,
      //           width: "80%",
      //           // min: 0,
      //           // max: 100,
      //           minSize: "0%",
      //           maxSize: "100%",
      //           sort: "ascending",
      //           gap: 2,
      //           label: {
      //             show: false,
      //             position: "inside",
      //             formatter: function (params) {
      //               return (+params.value).toLocaleString();
      //             },
      //           },
      //           emphasis: {
      //             focus: "series",
      //           },
      //           lineStyle: {
      //             color: "#A6170A",
      //             //color: this.colors[i],
      //             width: 1,
      //           },
      //           itemStyle: {
      //             borderWidth: 1,
      //             borderColor: "#A6170A",
      //             color: "#A6170A",
      //             //borderColor: this.colors[i],
      //             //color: this.colors[i]
      //           },
      //         },
      //       ],
      //     };
      //   }
      // } 
      else if (useCase == "UC6") {
        //if subgroup is multiple, on x-axis and area on y-axis
        let tpArr = [];
        let vData = {};
        let d = {};
        let sgNames = [];
        // let colorPalette = ["#B8372B", "#CF655B", "#ED9C94", "#FFCBC6"].reverse();
        if (swap) {
          showData.forEach((row) => {
            let tp = row.subgroup;
            let sgName = row.area;

            if (!sgNames.includes(sgName)) {
              sgNames.push(sgName);
            }

            if (!tpArr.includes(tp)) {
              tpArr.push(tp);
            }
            if (!(tp in d)) {
              d[tp] = {};
            }
            d[tp][sgName] = row.value;
          });
        } else {
          showData.forEach((row) => {
            let sgName = row.subgroup;
            if (!sgNames.includes(sgName)) {
              sgNames.push(sgName);
            }
            let tp = row.area;

            if (!tpArr.includes(tp)) {
              tpArr.push(tp);
            }
            if (!(tp in d)) {
              d[tp] = {};
            }
            d[tp][sgName] = row.value;
          });
        }
        for (let t of tpArr) {
          for (let sg of sgNames) {
            if (sg in vData) {
              vData[sg].push(d[t][sg]);
            } else {
              vData[sg] = [d[t][sg]];
            }
          }
        }

        let seri = [];
        const startColorIndex = colorPalette.length - sgNames.length;


        if (type == "line" || type == "bar") {
          sgNames.forEach((sg, i) => {
            const currentColor = colorPalette[startColorIndex + i] || colorPalette[i % colorPalette.length];
            seri.push({
              name: sg,
              data: vData[sg],
              colorBy: "data",
              type: type,
              label: {
                show: false,
                position: "top",
                formatter: function (params) {
                  return (+params.value).toLocaleString();
                },
              },
              emphasis: {
                focus: "series",
              },
              lineStyle: {
                color: "#A6170A",
                //color: this.colors[i],
                width: 1,
              },
              itemStyle: {
                color: currentColor,
                borderColor: currentColor,
              },
            });
          });

          oData = {
            tooltip: {
              trigger: "item",
              axisPointer: {
                type: "cross",
              },
            },
            legend: {
              data: tpArr,
              orient: "vertical",
              top: "5%",
              // icon: 'rect',
              right: 0,
              bottom: 0,
              // height: 'auto',
              itemGap: 14,
              type: "scroll",
              show: lgend,
              formatter: function (name) {
                return name.length > 17 ? name.substring(0, 17) + "..." : name;
              },
              tooltip: {
                show: true,
                trigger: "item",
              },
              textStyle: {
                color: "#333",
              },
            },
            grid: {
              containLabel: true,
              left: "0%",
              right: "18%",
              // height: 'auto',
              // bottom: '3%',
              top: "10%",
              y2: 30,
            },
            xAxis: {
              type: "category",  
              triggerEvent: true,
              data: sgNames,
              axisLabel: {
                color: "#333",
                width: 140,
                lineHeight: 14,
                overflow: "truncate",
                rotate: -40,
                interval: 0
              },
              axisLine: {
                lineStyle: {
                  color: "#333",
                },
              },
            },
            yAxis: {
              type: "value",
              axisLabel: {
                color: "#333",
                  width: 140,
                  lineHeight: 10,
                  overflow: "breakAll"
              },
              splitLine: {
                lineStyle: {
                  color: "#333",
                  type: "dashed",
                },
              },
            },
            toolbox: {
              show: false,
              orient: "vertical",
              left: "right",
              top: "center",
              feature: {
                mark: { show: true },
                dataView: { show: true, readOnly: true },
                magicType: { show: true, type: ["bar", "line"] },
                // restore: { show: true },
                saveAsImage: { show: true, title: "Download" },
              },
            },
            series: seri,
          };
        } else if (type == "funnel") {
          tpArr.forEach((tp, i) => {
            seri.push({
              name: tp,
              data: vData[tp],
              type: type,
              left: "10%",
              top: 60,
              bottom: 60,
              width: "80%",
              // min: 0,
              // max: 100,
              minSize: "0%",
              maxSize: "100%",
              sort: "ascending",
              gap: 2,
              label: {
                show: false,
                position: "inside",
                formatter: function (params) {
                  return (+params.value).toLocaleString();
                },
              },
              emphasis: {
                focus: "series",
              },
              lineStyle: {
                color: "#A6170A",
                //color: this.colors[i],
                width: 1,
              },
              itemStyle: {
                borderWidth: 1,
                borderColor: "#A6170A",
                color: "#A6170A",
                //borderColor: this.colors[i],
                //color: this.colors[i]
              },
            });
          });

          oData = {
            tooltip: {
              trigger: "item",
              axisPointer: {
                type: "cross",
              },
            },
            legend: {
              data: tpArr,
              // orient: 'vertical',
              // top: 'center',
              // icon: 'rect',
              // right: 0,
              bottom: 0,
              // height: 'auto',
              type: "scroll",
              show: lgend,
              formatter: function (name) {
                return name.length > 17 ? name.substring(0, 17) + "..." : name;
              },
              tooltip: {
                show: true,
                trigger: "item",
              },
              textStyle: {
                color: "#333",
              },
            },
            grid: {
              containLabel: true,
              left: "10%",
              // height: 'auto',
              // bottom: '3%',
              top: "10%",
              y2: 30,
            },
            series: seri,
          };
        }
      } else if (
        useCase == "UC14" ||
        useCase == "UC15" ||
        useCase == "UC16" ||
        useCase == "UC22"
      ) {
        //tp(Indicator/US/IU multiple) on x-axis and sg(Area) on Y-axis
        let tpArr = [];
        let vData = {};
        let d = {};
        let sgNames = [];
        // let colorPalette = ["#B8372B", "#CF655B", "#ED9C94", "#FFCBC6"].reverse();
        if (swap) {
          showData.forEach((row) => {
            let sgName = row.indicator;
            if (useCase == "UC14") {
              sgName = row.indicator;
            } else if (useCase == "UC15") {
              sgName = row.unit + "-" + row.subgroup;
            } else if (useCase == "UC16") {
              sgName = row.indicator + "-" + row.unit;
            } else if (useCase == "UC22") {
              sgName = row.unit;
            }

            let tp = row.area;

            if (!sgNames.includes(sgName)) {
              sgNames.push(sgName);
            }

            if (!tpArr.includes(tp)) {
              tpArr.push(tp);
            }
            if (!(tp in d)) {
              d[tp] = {};
            }
            d[tp][sgName] = row.value;
          });
        } else {
          showData.forEach((row) => {
            let tp = row.indicator;
            if (useCase == "UC14") {
              tp = row.indicator;
            } else if (useCase == "UC15") {
              tp = row.unit + "-" + row.subgroup;
            } else if (useCase == "UC16") {
              tp = row.indicator + "-" + row.unit;
            } else if (useCase == "UC22") {
              tp = row.unit;
            }

            let sgName = row.area;
            if (!sgNames.includes(sgName)) {
              sgNames.push(sgName);
            }

            if (!tpArr.includes(tp)) {
              tpArr.push(tp);
            }
            if (!(tp in d)) {
              d[tp] = {};
            }
            d[tp][sgName] = row.value;
          });
        }

        for (let t of tpArr) {
          for (let sg of sgNames) {
            if (sg in vData) {
              vData[sg].push(d[t][sg]);
            } else {
              vData[sg] = [d[t][sg]];
            }
          }
        }

        let seri = [];
        const startColorIndex = colorPalette.length - sgNames.length;


        if (type == "line" || type == "bar") {
          sgNames.forEach((sg, i) => {
            const currentColor = colorPalette[startColorIndex + i] || colorPalette[i % colorPalette.length];
            seri.push({
              name: sg,
              data: vData[sg],
              color: colorPalette,
              colorBy: "data",
              type: type,
              label: {
                show: false,
                position: "top",
                formatter: function (params) {
                  return (+params.value).toLocaleString();
                },
              },
              emphasis: {
                focus: "series",
              },
              lineStyle: {
                color: "#A6170A",
                //color: this.colors[i],
                width: 1,
              },
              itemStyle: {
                borderWidth: 1,
                borderColor: "#A6170A",
                color: "#A6170A",
                //borderColor: this.colors[i],
                //color: this.colors[i]
              },
            });
          });

          oData = {
            tooltip: {
              trigger: "item",
              axisPointer: {
                type: "cross",
              },
            },
            legend: {
              data: sgNames,
              orient: "vertical",
              top: "5%",
              // icon: 'rect',
              right: 0,
              bottom: 0,
              // height: 'auto',
              itemGap: 14,
              type: "scroll",
              show: lgend,
              formatter: function (name) {
                return name.length > 17 ? name.substring(0, 17) + "..." : name;
              },
              tooltip: {
                show: true,
                trigger: "item",
              },
              textStyle: {
                color: "#333",
              },
            },
            grid: {
              containLabel: true,
              left: "0%",
              right: "18%",
              // height: 'auto',
              // bottom: '3%',
              top: "10%",
              y2: 30,
            },
            xAxis: {
              type: "category",  
              triggerEvent: true,
              data: tpArr,
              axisLabel: {
                color: "#333",
                width: 140,
                lineHeight: 14,
                overflow: "truncate",
                rotate: -40,
                interval: 0
              },
              axisLine: {
                lineStyle: {
                  color: "#333",
                },
              },
            },
            yAxis: {
              type: "value",
              axisLabel: {
                color: "#333",
                  width: 140,
                  lineHeight: 10,
                  overflow: "breakAll"
              },
              splitLine: {
                lineStyle: {
                  color: "#333",
                  type: "dashed",
                },
              },
            },
            toolbox: {
              show: false,
              orient: "vertical",
              left: "right",
              top: "center",
              feature: {
                mark: { show: true },
                dataView: { show: true, readOnly: true },
                magicType: { show: true, type: ["bar", "line"] },
                // restore: { show: true },
                saveAsImage: { show: true, title: "Download" },
              },
            },
            series: seri,
          };
        } else if (type == "funnel") {
          sgNames.forEach((sg, i) => {
            seri.push({
              name: sg,
              data: vData[sg],
              type: type,
              left: "10%",
              top: 60,
              bottom: 60,
              width: "80%",
              // min: 0,
              // max: 100,
              minSize: "0%",
              maxSize: "100%",
              sort: "ascending",
              gap: 2,
              label: {
                show: false,
                position: "inside",
                formatter: function (params) {
                  return (+params.value).toLocaleString();
                },
              },
              emphasis: {
                focus: "series",
              },
              lineStyle: {
                color: "#A6170A",
                //color: this.colors[i],
                width: 1,
              },
              itemStyle: {
                borderWidth: 1,
                borderColor: "#A6170A",
                color: "#A6170A",
                //borderColor: this.colors[i],
                //color: this.colors[i]
              },
            });
          });

          oData = {
            tooltip: {
              trigger: "item",
              axisPointer: {
                type: "cross",
              },
            },
            legend: {
              data: sgNames,
              // orient: 'vertical',
              // top: 'center',
              // icon: 'rect',
              // right: 0,
              bottom: 0,
              // height: 'auto',
              type: "scroll",
              show: lgend,
              formatter: function (name) {
                return name.length > 17 ? name.substring(0, 17) + "..." : name;
              },
              tooltip: {
                show: true,
                trigger: "item",
              },
              textStyle: {
                color: "#333",
              },
            },
            grid: {
              containLabel: true,
              left: "10%",
              // height: 'auto',
              // bottom: '3%',
              top: "10%",
              y2: 30,
            },
            series: seri,
          };
        }
      } else if (
        useCase == "UC17" ||
        useCase == "UC18" ||
        useCase == "UC19" ||
        useCase == "UC20"
      ) {
        //tp(Subgroup/Indicator multiple) on x-axis and sg(timeperiod/Area/Subgroup) on Y-axis
        let tpArr = [];
        let vData = {};
        let d = {};
        let sgNames = [];
        // let colorPalette = ["#B8372B", "#CF655B", "#ED9C94", "#FFCBC6"].reverse();

        if (swap) {
          showData.forEach((row) => {
            let sgName = row.subgroup;
            if (useCase != "UC17") {
              sgName = row.indicator;
            }

            let tp = row.timeperiod;
            if (useCase == "UC19") {
              tp = row.area;
            } else if (useCase == "UC20") {
              tp = row.subgroup;
            }

            if (!sgNames.includes(sgName)) {
              sgNames.push(sgName);
            }

            if (!tpArr.includes(tp)) {
              tpArr.push(tp);
            }
            if (!(tp in d)) {
              d[tp] = {};
            }
            d[tp][sgName] = row.value;
          });
        } else {
          showData.forEach((row) => {
            let tp = row.subgroup;
            if (useCase != "UC17") {
              tp = row.indicator;
            }

            let sgName = row.timeperiod;
            if (useCase == "UC19") {
              sgName = row.area;
            } else if (useCase == "UC20") {
              sgName = row.subgroup;
            }

            if (!sgNames.includes(sgName)) {
              sgNames.push(sgName);
            }

            if (!tpArr.includes(tp)) {
              tpArr.push(tp);
            }
            if (!(tp in d)) {
              d[tp] = {};
            }
            d[tp][sgName] = row.value;
          });
        }

        for (let t of tpArr) {
          for (let sg of sgNames) {
            if (sg in vData) {
              vData[sg].push(d[t][sg]);
            } else {
              vData[sg] = [d[t][sg]];
            }
          }
        }

        let seri = [];
        const startColorIndex = colorPalette.length - sgNames.length;


        if (type == "line" || type == "bar") {
          sgNames.forEach((sg, i) => {
            const currentColor = colorPalette[startColorIndex + i] || colorPalette[i % colorPalette.length];
            seri.push({
              name: sg,
              data: vData[sg],
              colorBy: "data",
              type: type,
              label: {
                show: false,
                position: "top",
                formatter: function (params) {
                  return (+params.value).toLocaleString();
                },
              },
              emphasis: {
                focus: "series",
              },
              lineStyle: {
                color: "#A6170A",
                //color: this.colors[i],
                width: 1,
              },
              itemStyle: {
                color: currentColor,
                borderColor: currentColor,
              },
            });
          });

          oData = {
            tooltip: {
              trigger: "item",
              axisPointer: {
                type: "cross",
              },
            },
            legend: {
              data: sgNames,
              orient: "vertical",
              top: "5%",
              // icon: 'rect',
              right: 0,
              bottom: 0,
              // height: 'auto',
              itemGap: 14,
              type: "scroll",
              show: lgend,
              formatter: function (name) {
                return name.length > 17 ? name.substring(0, 17) + "..." : name;
              },
              tooltip: {
                show: true,
                trigger: "item",
              },
              textStyle: {
                color: "#333",
              },
            },
            grid: {
              containLabel: true,
              left: "0%",
              right: "18%",
              // height: 'auto',
              // bottom: '3%',
              top: "10%",
              y2: 30,
            },
            xAxis: {
              type: "category",  
              triggerEvent: true,
              data: tpArr,
              axisLabel: {
                color: "#333",
                width: 140,
                lineHeight: 14,
                overflow: "truncate",
                rotate: -40,
                interval: 0
              },
              axisLine: {
                lineStyle: {
                  color: "#333",
                },
              },
            },
            yAxis: {
              type: "value",
              axisLabel: {
                color: "#333",
                  width: 140,
                  lineHeight: 10,
                  overflow: "breakAll"
              },
              splitLine: {
                lineStyle: {
                  color: "#333",
                  type: "dashed",
                },
              },
            },
            toolbox: {
              show: false,
              orient: "vertical",
              left: "right",
              top: "center",
              feature: {
                mark: { show: true },
                dataView: { show: true, readOnly: true },
                magicType: { show: true, type: ["bar", "line"] },
                // restore: { show: true },
                saveAsImage: { show: true, title: "Download" },
              },
            },
            series: seri,
          };
        } else if (type == "funnel") {
          sgNames.forEach((sg, i) => {
            seri.push({
              name: sg,
              data: vData[sg],
              type: type,
              left: "10%",
              top: 60,
              bottom: 60,
              width: "80%",
              // min: 0,
              // max: 100,
              minSize: "0%",
              maxSize: "100%",
              sort: "ascending",
              gap: 2,
              label: {
                show: false,
                position: "inside",
                formatter: function (params) {
                  return (+params.value).toLocaleString();
                },
              },
              emphasis: {
                focus: "series",
              },
              lineStyle: {
                color: "#A6170A",
                //color: this.colors[i],
                width: 1,
              },
              itemStyle: {
                borderWidth: 1,
                borderColor: "#A6170A",
                color: "#A6170A",
                //borderColor: this.colors[i],
                //color: this.colors[i]
              },
            });
          });

          oData = {
            tooltip: {
              trigger: "item",
              axisPointer: {
                type: "cross",
              },
            },
            legend: {
              data: sgNames,
              // orient: 'vertical',
              // top: 'center',
              // icon: 'rect',
              // right: 0,
              bottom: 0,
              // height: 'auto',
              type: "scroll",
              show: lgend,
              formatter: function (name) {
                return name.length > 17 ? name.substring(0, 17) + "..." : name;
              },
              tooltip: {
                show: true,
                trigger: "item",
              },
              textStyle: {
                color: "#333",
              },
            },
            grid: {
              containLabel: true,
              left: "10%",
              // height: 'auto',
              // bottom: '3%',
              top: "10%",
              y2: 30,
            },
            series: seri,
          };
        }
      } else if (useCase == "UC21" || useCase == "UC23" || useCase == "UC24") {
        //tp(US multiple) on x-axis and sg(Area/TP) on Y-axis
        let tpArr = [];
        let vData = {};
        let d = {};
        let sgNames = [];
        // let colorPalette = ["#B8372B", "#CF655B", "#ED9C94", "#FFCBC6"].reverse();

        if (swap) {
          showData.forEach((row) => {
            let sgName = row.unit + "-" + row.subgroup;

            let tp = row.area + "-" + row.timeperiod;
            if (useCase == "UC23") {
              tp = row.area;
            } else if (useCase == "UC24") {
              tp = row.timeperiod;
            }

            if (!sgNames.includes(sgName)) {
              sgNames.push(sgName);
            }

            if (!tpArr.includes(tp)) {
              tpArr.push(tp);
            }
            if (!(tp in d)) {
              d[tp] = {};
            }
            d[tp][sgName] = row.value;
          });
        } else {
          showData.forEach((row) => {
            let tp = row.unit + "-" + row.subgroup;

            let sgName = row.area + "-" + row.timeperiod;
            if (useCase == "UC23") {
              sgName = row.area;
            } else if (useCase == "UC24") {
              sgName = row.timeperiod;
            }

            if (!sgNames.includes(sgName)) {
              sgNames.push(sgName);
            }

            if (!tpArr.includes(tp)) {
              tpArr.push(tp);
            }
            if (!(tp in d)) {
              d[tp] = {};
            }
            d[tp][sgName] = row.value;
          });
        }

        for (let t of tpArr) {
          for (let sg of sgNames) {
            if (sg in vData) {
              vData[sg].push(d[t][sg]);
            } else {
              vData[sg] = [d[t][sg]];
            }
          }
        }
        let seri = [];
        const startColorIndex = colorPalette.length - sgNames.length;

        if (type == "line" || type == "bar") {
          sgNames.forEach((sg, i) => {
            const currentColor = colorPalette[startColorIndex + i] || colorPalette[i % colorPalette.length];
            seri.push({
              name: sg,
              data: vData[sg],
              type: type,
              label: {
                show: false,
                position: "top",
                formatter: function (params) {
                  return (+params.value).toLocaleString();
                },
              },
              emphasis: {
                focus: "series",
              },
              lineStyle: {
                color: "#A6170A",
                //color: this.colors[i],
                width: 1,
              },
              itemStyle: {
                color: currentColor,
                borderColor: currentColor,
              },
            });
          });

          oData = {
            tooltip: {
              trigger: "item",
              axisPointer: {
                type: "cross",
              },
            },
            legend: {
              data: sgNames,
              orient: "vertical",
              top: "5%",
              // icon: 'rect',
              right: 0,
              bottom: 0,
              // height: 'auto',
              itemGap: 14,
              type: "scroll",
              show: lgend,
              formatter: function (name) {
                return name.length > 17 ? name.substring(0, 17) + "..." : name;
              },
              tooltip: {
                show: true,
                trigger: "item",
              },
              textStyle: {
                color: "#333",
              },
            },
            grid: {
              containLabel: true,
              left: "0%",
              right: "18%",
              // height: 'auto',
              // bottom: '3%',
              top: "10%",
              y2: 30,
            },
            xAxis: {
              type: "category",  
              triggerEvent: true,
              data: tpArr,
              axisLabel: {
                color: "#333",
                width: 140,
                lineHeight: 14,
                overflow: "truncate",
                rotate: -40,
                interval: 0
              },
              axisLine: {
                lineStyle: {
                  color: "#333",
                },
              },
            },
            yAxis: {
              type: "value",
              axisLabel: {
                color: "#333",
                  width: 140,
                  lineHeight: 10,
                  overflow: "breakAll"
              },
              splitLine: {
                lineStyle: {
                  color: "#333",
                  type: "dashed",
                },
              },
            },
            toolbox: {
              show: false,
              orient: "vertical",
              left: "right",
              top: "center",
              feature: {
                mark: { show: true },
                dataView: { show: true, readOnly: true },
                magicType: { show: true, type: ["bar", "line"] },
                // restore: { show: true },
                saveAsImage: { show: true, title: "Download" },
              },
            },
            series: seri,
          };
        } else if (type == "funnel") {
          sgNames.forEach((sg, i) => {
            seri.push({
              name: sg,
              data: vData[sg],
              type: type,
              left: "10%",
              top: 60,
              bottom: 60,
              width: "80%",
              // min: 0,
              // max: 100,
              minSize: "0%",
              maxSize: "100%",
              sort: "ascending",
              gap: 2,
              label: {
                show: false,
                position: "inside",
                formatter: function (params) {
                  return (+params.value).toLocaleString();
                },
              },
              emphasis: {
                focus: "series",
              },
              lineStyle: {
                color: "#A6170A",
                //color: this.colors[i],
                width: 1,
              },
              itemStyle: {
                borderWidth: 1,
                borderColor: "#A6170A",
                color: "#A6170A",
                //borderColor: this.colors[i],
                //color: this.colors[i]
              },
            });
          });

          oData = {
            tooltip: {
              trigger: "item",
              axisPointer: {
                type: "cross",
              },
            },
            legend: {
              data: sgNames,
              // orient: 'vertical',
              // top: 'center',
              // icon: 'rect',
              // right: 0,
              bottom: 0,
              // height: 'auto',
              type: "scroll",
              show: lgend,
              formatter: function (name) {
                return name.length > 17 ? name.substring(0, 17) + "..." : name;
              },
              tooltip: {
                show: true,
                trigger: "item",
              },
              textStyle: {
                color: "#333",
              },
            },
            grid: {
              containLabel: true,
              left: "10%",
              // height: 'auto',
              // bottom: '3%',
              top: "10%",
              y2: 30,
            },
            series: seri,
          };
        }
      } else if (
        useCase == "UC25" ||
        useCase == "UC26" ||
        useCase == "UC27" ||
        useCase == "UC28" ||
        useCase == "UC29"
      ) {
        //tp(IU multiple) on x-axis and sg(timeperiod/Area) on Y-axis
        let tpArr = [];
        let vData = {};
        let d = {};
        let sgNames = [];
        // let colorPalette = ["#B8372B", "#CF655B", "#ED9C94", "#FFCBC6"].reverse();

        if (swap) {
          showData.forEach((row) => {
            let sgName = row.indicator;
            if (useCase == "UC25" || useCase == "UC26" || useCase == "UC27") {
              sgName = sgName + "-" + row.subgroup;
            } else if (useCase == "UC28" || useCase == "UC29") {
              sgName = sgName + "-" + row.unit;
            }

            let tp = row.area;
            if (useCase == "UC26") {
              tp = tp + "-" + row.timeperiod;
            } else if (useCase == "UC27" || useCase == "UC28") {
              tp = row.timeperiod;
            }

            if (!sgNames.includes(sgName)) {
              sgNames.push(sgName);
            }

            if (!tpArr.includes(tp)) {
              tpArr.push(tp);
            }
            if (!(tp in d)) {
              d[tp] = {};
            }
            d[tp][sgName] = row.value;
          });
        } else {
          showData.forEach((row) => {
            let tp = row.indicator;
            if (useCase == "UC25" || useCase == "UC26" || useCase == "UC27") {
              tp = tp + "-" + row.subgroup;
            } else if (useCase == "UC28" || useCase == "UC29") {
              tp = tp + "-" + row.unit;
            }

            let sgName = row.area;
            if (useCase == "UC26") {
              sgName = sgName + "-" + row.timeperiod;
            } else if (useCase == "UC27" || useCase == "UC28") {
              sgName = row.timeperiod;
            }

            if (!sgNames.includes(sgName)) {
              sgNames.push(sgName);
            }

            if (!tpArr.includes(tp)) {
              tpArr.push(tp);
            }
            if (!(tp in d)) {
              d[tp] = {};
            }
            d[tp][sgName] = row.value;
          });
        }

        for (let t of tpArr) {
          for (let sg of sgNames) {
            if (sg in vData) {
              vData[sg].push(d[t][sg]);
            } else {
              vData[sg] = [d[t][sg]];
            }
          }
        }

        let seri = [];
        const startColorIndex = colorPalette.length - sgNames.length;

        if (type == "line" || type == "bar") {
          sgNames.forEach((sg, i) => {
            const currentColor = colorPalette[startColorIndex + i] || colorPalette[i % colorPalette.length];
            seri.push({
              name: sg,
              data: vData[sg],
              colorBy: "data",
              type: type,
              label: {
                show: false,
                position: "top",
                formatter: function (params) {
                  return (+params.value).toLocaleString();
                },
              },
              emphasis: {
                focus: "series",
              },
              lineStyle: {
                color: "#A6170A",
                //color: this.colors[i],
                width: 1,
              },
              itemStyle: {
                color: currentColor,
                borderColor: currentColor,
              },
            });
          });

          oData = {
            tooltip: {
              trigger: "item",
              axisPointer: {
                type: "cross",
              },
            },
            legend: {
              data: sgNames,
              orient: "vertical",
              top: "5%",
              // icon: 'rect',
              right: 0,
              bottom: 0,
              // height: 'auto',
              itemGap: 14,
              type: "scroll",
              show: lgend,
              formatter: function (name) {
                return name.length > 17 ? name.substring(0, 17) + "..." : name;
              },
              tooltip: {
                show: true,
                trigger: "item",
              },
              textStyle: {
                color: "#333",
              },
            },
            grid: {
              containLabel: true,
              left: "0%",
              right: "18%",
              // height: 'auto',
              // bottom: '3%',
              top: "10%",
              y2: 30,
            },
            xAxis: {
              type: "category",  
              triggerEvent: true,
              data: tpArr,
              axisLabel: {
                color: "#333",
                width: 140,
                lineHeight: 14,
                overflow: "truncate",
                rotate: -40,
                interval: 0
              },
              axisLine: {
                lineStyle: {
                  color: "#333",
                },
              },
            },
            yAxis: {
              type: "value",
              axisLabel: {
                color: "#333",
                  width: 140,
                  lineHeight: 10,
                  overflow: "breakAll"
              },
              splitLine: {
                lineStyle: {
                  color: "#333",
                  type: "dashed",
                },
              },
            },
            toolbox: {
              show: false,
              orient: "vertical",
              left: "right",
              top: "center",
              feature: {
                mark: { show: true },
                dataView: { show: true, readOnly: true },
                magicType: { show: true, type: ["bar", "line"] },
                // restore: { show: true },
                saveAsImage: { show: true, title: "Download" },
              },
            },
            series: seri,
          };
        } else if (type == "funnel") {
          sgNames.forEach((sg, i) => {
            seri.push({
              name: sg,
              data: vData[sg],
              type: type,
              left: "10%",
              top: 60,
              bottom: 60,
              width: "80%",
              // min: 0,
              // max: 100,
              minSize: "0%",
              maxSize: "100%",
              sort: "ascending",
              gap: 2,
              label: {
                show: false,
                position: "inside",
                formatter: function (params) {
                  return (+params.value).toLocaleString();
                },
              },
              emphasis: {
                focus: "series",
              },
              lineStyle: {
                color: "#A6170A",
                //color: this.colors[i],
                width: 1,
              },
              itemStyle: {
                borderWidth: 1,
                borderColor: "#A6170A",
                color: "#A6170A",
                //borderColor: this.colors[i],
                //color: this.colors[i]
              },
            });
          });

          oData = {
            tooltip: {
              trigger: "item",
              axisPointer: {
                type: "cross",
              },
            },
            legend: {
              data: sgNames,
              // orient: 'vertical',
              // top: 'center',
              // icon: 'rect',
              // right: 0,
              bottom: 0,
              // height: 'auto',
              type: "scroll",
              show: lgend,
              formatter: function (name) {
                return name.length > 17 ? name.substring(0, 17) + "..." : name;
              },
              tooltip: {
                show: true,
                trigger: "item",
              },
              textStyle: {
                color: "#333",
              },
            },
            grid: {
              containLabel: true,
              left: "10%",
              // height: 'auto',
              // bottom: '3%',
              top: "10%",
              y2: 30,
            },
            series: seri,
          };
        }
      } else if (useCase == "UC30" || useCase == "UC31" || useCase == "UC32") {
        //tp(IUS multiple) on x-axis and sg(timeperiod/Area) on Y-axis
        let tpArr = [];
        let vData = {};
        let d = {};
        let sgNames = [];
        // let colorPalette = ["#B8372B", "#CF655B", "#ED9C94", "#FFCBC6"].reverse();

        if (swap) {
          showData.forEach((row) => {
            let sgName = row.indicator + "-" + row.unit + "-" + row.subgroup;

            let tp = row.area;
            if (useCase == "UC32") {
              tp = row.timeperiod;
            }

            if (!sgNames.includes(sgName)) {
              sgNames.push(sgName);
            }

            if (!tpArr.includes(tp)) {
              tpArr.push(tp);
            }
            if (!(tp in d)) {
              d[tp] = {};
            }
            d[tp][sgName] = row.value;
          });
        } else {
          showData.forEach((row) => {
            let tp = row.indicator + "-" + row.unit + "-" + row.subgroup;

            let sgName = row.area;
            if (useCase == "UC32") {
              sgName = row.timeperiod;
            }

            if (!sgNames.includes(sgName)) {
              sgNames.push(sgName);
            }

            if (!tpArr.includes(tp)) {
              tpArr.push(tp);
            }
            if (!(tp in d)) {
              d[tp] = {};
            }
            d[tp][sgName] = row.value;
          });
        }

        for (let t of tpArr) {
          for (let sg of sgNames) {
            if (sg in vData) {
              vData[sg].push(d[t][sg]);
            } else {
              vData[sg] = [d[t][sg]];
            }
          }
        }

        let seri = [];
        const startColorIndex = colorPalette.length - sgNames.length;


        if (type == "line" || type == "bar") {
          sgNames.forEach((sg, i) => {
            const currentColor = colorPalette[startColorIndex + i] || colorPalette[i % colorPalette.length];
            seri.push({
              name: sg,
              data: vData[sg],
              colorBy: "data",
              type: type,
              label: {
                show: false,
                position: "top",
                formatter: function (params) {
                  return (+params.value).toLocaleString();
                },
              },
              emphasis: {
                focus: "series",
              },
              lineStyle: {
                color: "#A6170A",
                //color: this.colors[i],
                width: 1,
              },
              itemStyle: {
                color: currentColor,
                borderColor: currentColor,
              },
            });
          });

          oData = {
            tooltip: {
              trigger: "item",
              axisPointer: {
                type: "cross",
              },
            },
            legend: {
              data: sgNames,
              orient: "vertical",
              top: "5%",
              // icon: 'rect',
              right: 0,
              bottom: 0,
              // height: 'auto',
              itemGap: 14,
              type: "scroll",
              show: lgend,
              formatter: function (name) {
                return name.length > 17 ? name.substring(0, 17) + "..." : name;
              },
              tooltip: {
                show: true,
                trigger: "item",
              },
              textStyle: {
                color: "#333",
              },
            },
            grid: {
              containLabel: true,
              left: "0%",
              right: "18%",
              // height: 'auto',
              // bottom: '3%',
              top: "10%",
              y2: 30,
            },
            xAxis: {
              type: "category",  
              triggerEvent: true,
              data: tpArr,
              axisLabel: {
                color: "#333",
                width: 140,
                lineHeight: 14,
                overflow: "truncate",
                rotate: -40,
                interval: 0
              },
              axisLine: {
                lineStyle: {
                  color: "#333",
                },
              },
            },
            yAxis: {
              type: "value",
              axisLabel: {
                color: "#333",
                  width: 140,
                  lineHeight: 10,
                  overflow: "breakAll"
              },
              splitLine: {
                lineStyle: {
                  color: "#333",
                  type: "dashed",
                },
              },
            },
            toolbox: {
              show: false,
              orient: "vertical",
              left: "right",
              top: "center",
              feature: {
                mark: { show: true },
                dataView: { show: true, readOnly: true },
                magicType: { show: true, type: ["bar", "line"] },
                // restore: { show: true },
                saveAsImage: { show: true, title: "Download" },
              },
            },
            series: seri,
          };
        } else if (type == "funnel") {
          sgNames.forEach((sg, i) => {
            seri.push({
              name: sg,
              data: vData[sg],
              type: type,
              left: "10%",
              top: 60,
              bottom: 60,
              width: "80%",
              // min: 0,
              // max: 100,
              minSize: "0%",
              maxSize: "100%",
              sort: "ascending",
              gap: 2,
              label: {
                show: false,
                position: "inside",
                formatter: function (params) {
                  return (+params.value).toLocaleString();
                },
              },
              emphasis: {
                focus: "series",
              },
              lineStyle: {
                color: "#A6170A",
                //color: this.colors[i],
                width: 1,
              },
              itemStyle: {
                borderWidth: 1,
                borderColor: "#A6170A",
                color: "#A6170A",
                //borderColor: this.colors[i],
                //color: this.colors[i]
              },
            });
          });

          oData = {
            tooltip: {
              trigger: "item",
              axisPointer: {
                type: "cross",
              },
            },
            legend: {
              data: sgNames,
              // orient: 'vertical',
              // top: 'center',
              // icon: 'rect',
              // right: 0,
              bottom: 0,
              // height: 'auto',
              type: "scroll",
              show: lgend,
              formatter: function (name) {
                return name.length > 17 ? name.substring(0, 17) + "..." : name;
              },
              tooltip: {
                show: true,
                trigger: "item",
              },
              textStyle: {
                color: "#333",
              },
            },
            grid: {
              containLabel: true,
              left: "10%",
              // height: 'auto',
              // bottom: '3%',
              top: "10%",
              y2: 30,
            },
            series: seri,
          };
        }
      }
    } else if (type == "pie") {
      // let colorPalette = colorPaletteState;
      if (
        useCase == "UC2" ||
        useCase == "UC3" ||
        useCase == "UC5" ||
        useCase == "UC14"
      ) {
        //1-dimension multiple
        let iusArr = [];
        let vData = [];
        let legendData = [];
        let seri=[]
        showData.forEach((row) => {
          let tpName=row?.timeperiod;
          let sgName=row?.subgroup;
          if (useCase == "UC2") {
            iusArr.push(row.timeperiod);
            tpName=row?.timeperiod
          } else if (useCase == "UC3") {
            iusArr.push(row.area);
            tpName=row?.area
          } else if (useCase == "UC5") {
            iusArr.push(row.subgroup);
            sgName=row?.subgroup
          } else if (useCase == "UC14") {
            iusArr.push(row.indicator);
            tpName=row?.indicator
          }

          vData.push(row.value);
          legendData.push(sgName + "-" + tpName)
          seri.push({
            name: sgName + "-" + tpName,
            value: row.value,
          });
        });


        oData = {
          tooltip: {
            trigger: "item",
          },
          legend: {
            type: "scroll",
            orient: "vertical",
            right: 10,
            top: 20,
            bottom: 20,
            itemGap: 14,
            data: legendData,
            show: lgend,
            formatter: function (name) {
              console.log(name,"sdfghjjhghrgefghjghj")
              return name.length > 17 ? name.substring(0, 34) + "..." : name;
            },
            tooltip: {
              show: true,
              trigger: "item",
            },
            textStyle: {
              color: "#333",
            },
          },
          series: [
            {
              name: "",
              type: "pie",
              // radius: '75%',
              center: ["40%", "50%"],
              data: seri,
              color: colorPalette,
              label: {
                show: false,
              },
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)",
                },
              },
            },
          ],
        };
      } else if (
        useCase == "UC4" ||
        useCase == "UC6" ||
        useCase == "UC12" ||
        useCase == "UC13" ||
        useCase == "UC15" ||
        useCase == "UC16" ||
        useCase == "UC17" ||
        useCase == "UC18" ||
        useCase == "UC19" ||
        useCase == "UC20" ||
        useCase == "UC22" ||
        useCase == "UC23" ||
        useCase == "UC24"
      ) {
        //2-dimensions are multiple

        let legendData = [];
        let seri = [];
        showData.forEach((row) => {
          let sgName = row.area;
          let tp = row.timeperiod;
          if (useCase == "UC6") {
            sgName = row.subgroup;
            tp = row.area;
          } else if (useCase == "UC12") {
            sgName = row.timeperiod;
            tp = row.unit;
          } else if (useCase == "UC13") {
            sgName = row.area;
            tp = row.unit;
          } else if (useCase == "UC15") {
            sgName = row.subgroup;
            tp = row.unit;
          } else if (useCase == "UC16") {
            sgName = row.indicator;
            tp = row.unit;
          } else if (useCase == "UC17") {
            sgName = row.subgroup;
            tp = row.timeperiod;
          } else if (useCase == "UC18") {
            sgName = row.indicator;
            tp = row.timeperiod;
          } else if (useCase == "UC19") {
            sgName = row.indicator;
            tp = row.area;
          } else if (useCase == "UC20") {
            sgName = row.indicator;
            tp = row.subgroup;
          } else if (useCase == "UC22") {
            sgName = row.area;
            tp = row.unit;
          } else if (useCase == "UC23") {
            sgName = row.unit + "|" + row.subgroup;
            tp = row.timeperiod;
          } else if (useCase == "UC23") {
            sgName = row.unit + "|" + row.subgroup;
            tp = row.area;
          }
          legendData.push(sgName + "-" + tp);
          seri.push({
            name: sgName + "-" + tp,
            value: row.value,
          });
        });

        oData = {
          tooltip: {
            trigger: "item",
          },
          legend: {
            type: "scroll",
            orient: "vertical",
            right: 10,
            top: 20,
            itemGap: 14,
            bottom: 20,
            data: legendData,
            show: lgend,
            formatter: function (name) {
              console.log(name,"sdfghjjhghrgefghjghj1")
              return name.length > 17 ? name.substring(0, 34) + "..." : name;
            },
            tooltip: {
              show: true,
              trigger: "item",
            },
            textStyle: {
              color: "#333",
            },
          },
          series: [
            {
              name: "",
              type: "pie",
              // radius: '55%',
              center: ["40%", "50%"],
              data: seri,
              color: colorPalette,
              label: {
                show: false,
              },
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)",
                },
              },
            },
          ],
        };
      } else if (
        useCase == "UC7" ||
        useCase == "UC8" ||
        useCase == "UC9" ||
        useCase == "UC10" ||
        useCase == "UC11" ||
        useCase == "UC21" ||
        useCase == "UC25" ||
        useCase == "UC26" ||
        useCase == "UC27" ||
        useCase == "UC28" ||
        useCase == "UC29" ||
        useCase == "UC30" ||
        useCase == "UC31" ||
        useCase == "UC32"
      ) {
        //3+ dimensions are multiple
        let legendData = [];
        let seri = [];
        showData.forEach((row) => {
          let sgName = row.subgroup;
          let area = row.area;
          let tp = row.timeperiod;
          if (useCase == "UC8") {
            sgName = row.indicator;
            area = row.area;
            tp = row.timeperiod;
          } else if (useCase == "UC9") {
            sgName = row.indicator + "|" + row.unit;
            area = row.area;
            tp = row.timeperiod;
          } else if (useCase == "UC10") {
            sgName = row.indicator + "|" + row.unit + "|" + row.subgroup;
            area = row.area;
            tp = row.timeperiod;
          } else if (useCase == "UC11") {
            sgName = row.area;
            area = row.timeperiod;
            tp = row.unit;
          } else if (useCase == "UC21") {
            sgName = row.unit + "|" + row.subgroup;
            area = row.area;
            tp = row.timeperiod;
          } else if (useCase == "UC25") {
            sgName = row.indicator;
            area = row.subgroup;
            tp = row.area;
          } else if (useCase == "UC26") {
            sgName = row.indicator + "|" + row.subgroup;
            area = row.area;
            tp = row.timeperiod;
          } else if (useCase == "UC27") {
            sgName = row.indicator;
            area = row.subgroup;
            tp = row.timeperiod;
          } else if (useCase == "UC28") {
            sgName = row.indicator;
            area = row.unit;
            tp = row.timeperiod;
          } else if (useCase == "UC29") {
            sgName = row.indicator;
            area = row.unit;
            tp = row.area;
          } else if (useCase == "UC30") {
            sgName = row.indicator;
            area = row.unit;
            tp = row.subgroup;
          } else if (useCase == "UC31") {
            sgName = row.indicator + "|" + row.unit;
            area = row.subgroup;
            tp = row.area;
          } else if (useCase == "UC32") {
            sgName = row.indicator + "|" + row.unit;
            area = row.subgroup;
            tp = row.timeperiod;
          }
          legendData.push(sgName + "-" + area + "-" + tp);
          seri.push({
            name: sgName + "-" + area + "-" + tp,
            value: row.value,
          });
        });

        oData = {
          tooltip: {
            trigger: "item",
          },
          legend: {
            type: "scroll",
            orient: "vertical",
            right: 10,
            top: 20,
            bottom: 20,
            itemGap: 14,
            data: legendData,
            show: lgend,
            formatter: function (name) {
              console.log(name,"sdfghjjhghrgefghjghj")
              return name.length > 17 ? name.substring(0, 34) + "..." : name;
            },
            tooltip: {
              show: true,
              trigger: "item",
            },
            textStyle: {
              color: "#333",
            },
          },
          series: [
            {
              name: "",
              type: "pie",
              // radius: '55%',
              center: ["40%", "50%"],
              data: seri,
              color: colorPalette,
              label: {
                show: false,
              },
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)",
                },
              },
            },
          ],
        };
      }
    } else if (type == "doughnut") {
      // let colorPalette = colorPaletteState;
      if (
        useCase == "UC2" ||
        useCase == "UC3" ||
        useCase == "UC5" ||
        useCase == "UC14"
      ) {
        //1-dimension multiple
        let iusArr = [];
        let vData = [];
        let legendData = [];
        let seri=[]
        showData.forEach((row) => {
          let tpName=row?.timeperiod;
          let sgName=row?.subgroup;
          if (useCase == "UC2") {
            iusArr.push(row.timeperiod);
            tpName=row?.timeperiod
          } else if (useCase == "UC3") {
            iusArr.push(row.area);
            tpName=row?.area
          } else if (useCase == "UC5") {
            iusArr.push(row.subgroup);
            sgName=row?.subgroup
          } else if (useCase == "UC14") {
            iusArr.push(row.indicator);
            tpName=row?.indicator
          }

          vData.push(row.value);
          legendData.push(sgName + "-" + tpName)
          seri.push({
            name: sgName + "-" + tpName,
            value: row.value,
          });
        });

        oData = {
          tooltip: {
            trigger: "item",
          },
          legend: {
            type: "scroll",
            orient: "vertical",
            right: 10,
            top: 20,
            bottom: 20,
            itemGap: 14,
            data: legendData,
            show: lgend,
            formatter: function (name) {
              return name.length > 17 ? name.substring(0, 34) + "..." : name;
            },
            tooltip: {
              show: true,
              trigger: "item",
            },
            textStyle: {
              color: "#333",
            },
          },
          series: [
            {
              name: "",
              type: "pie",
              radius: ["40%", "70%"],
              //   center: ['40%', '50%'],
              data: seri,
              color: colorPalette,
              label: {
                show: false,
              },
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)",
                },
              },
            },
          ],
        };
      } else if (
        useCase == "UC4" ||
        useCase == "UC6" ||
        useCase == "UC12" ||
        useCase == "UC13" ||
        useCase == "UC15" ||
        useCase == "UC16" ||
        useCase == "UC17" ||
        useCase == "UC18" ||
        useCase == "UC19" ||
        useCase == "UC20" ||
        useCase == "UC22" ||
        useCase == "UC23" ||
        useCase == "UC24"
      ) {
        //2-dimensions are multiple

        let legendData = [];
        let seri = [];
        showData.forEach((row) => {
          let sgName = row.area;
          let tp = row.timeperiod;
          if (useCase == "UC6") {
            sgName = row.subgroup;
            tp = row.area;
          } else if (useCase == "UC12") {
            sgName = row.timeperiod;
            tp = row.unit;
          } else if (useCase == "UC13") {
            sgName = row.area;
            tp = row.unit;
          } else if (useCase == "UC15") {
            sgName = row.subgroup;
            tp = row.unit;
          } else if (useCase == "UC16") {
            sgName = row.indicator;
            tp = row.unit;
          } else if (useCase == "UC17") {
            sgName = row.subgroup;
            tp = row.timeperiod;
          } else if (useCase == "UC18") {
            sgName = row.indicator;
            tp = row.timeperiod;
          } else if (useCase == "UC19") {
            sgName = row.indicator;
            tp = row.area;
          } else if (useCase == "UC20") {
            sgName = row.indicator;
            tp = row.subgroup;
          } else if (useCase == "UC22") {
            sgName = row.area;
            tp = row.unit;
          } else if (useCase == "UC23") {
            sgName = row.unit + "|" + row.subgroup;
            tp = row.timeperiod;
          } else if (useCase == "UC23") {
            sgName = row.unit + "|" + row.subgroup;
            tp = row.area;
          }
          legendData.push(sgName + "-" + tp);
          seri.push({
            name: sgName + "-" + tp,
            value: row.value,
          });
        });

        oData = {
          tooltip: {
            trigger: "item",
          },
          legend: {
            type: "scroll",
            orient: "vertical",
            right: 10,
            top: 20,
            bottom: 20,
            itemGap: 14,
            data: legendData,
            show : legend,
            formatter: function (name) {
              return name.length > 17 ? name.substring(0, 34) + "..." : name;
            },
            tooltip: {
              show: true,
              trigger: "item",
            },
            textStyle: {
              color: "#333",
            },
          },
          series: [
            {
              name: "",
              type: "pie",
              radius: ["40%", "70%"],
              // center: ['40%', '50%'],
              data: seri,
              color: colorPalette,
              label: {
                show: false,
              },
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)",
                },
              },
            },
          ],
        };
      } else if (
        useCase == "UC7" ||
        useCase == "UC8" ||
        useCase == "UC9" ||
        useCase == "UC10" ||
        useCase == "UC11" ||
        useCase == "UC21" ||
        useCase == "UC25" ||
        useCase == "UC26" ||
        useCase == "UC27" ||
        useCase == "UC28" ||
        useCase == "UC29" ||
        useCase == "UC30" ||
        useCase == "UC31" ||
        useCase == "UC32"
      ) {
        //3+ dimensions are multiple
        let legendData = [];
        let seri = [];
        showData.forEach((row) => {
          let sgName = row.subgroup;
          let area = row.area;
          let tp = row.timeperiod;
          if (useCase == "UC8") {
            sgName = row.indicator;
            area = row.area;
            tp = row.timeperiod;
          } else if (useCase == "UC9") {
            sgName = row.indicator + "|" + row.unit;
            area = row.area;
            tp = row.timeperiod;
          } else if (useCase == "UC10") {
            sgName = row.indicator + "|" + row.unit + "|" + row.subgroup;
            area = row.area;
            tp = row.timeperiod;
          } else if (useCase == "UC11") {
            sgName = row.area;
            area = row.timeperiod;
            tp = row.unit;
          } else if (useCase == "UC21") {
            sgName = row.unit + "|" + row.subgroup;
            area = row.area;
            tp = row.timeperiod;
          } else if (useCase == "UC25") {
            sgName = row.indicator;
            area = row.subgroup;
            tp = row.area;
          } else if (useCase == "UC26") {
            sgName = row.indicator + "|" + row.subgroup;
            area = row.area;
            tp = row.timeperiod;
          } else if (useCase == "UC27") {
            sgName = row.indicator;
            area = row.subgroup;
            tp = row.timeperiod;
          } else if (useCase == "UC28") {
            sgName = row.indicator;
            area = row.unit;
            tp = row.timeperiod;
          } else if (useCase == "UC29") {
            sgName = row.indicator;
            area = row.unit;
            tp = row.area;
          } else if (useCase == "UC30") {
            sgName = row.indicator;
            area = row.unit;
            tp = row.subgroup;
          } else if (useCase == "UC31") {
            sgName = row.indicator + "|" + row.unit;
            area = row.subgroup;
            tp = row.area;
          } else if (useCase == "UC32") {
            sgName = row.indicator + "|" + row.unit;
            area = row.subgroup;
            tp = row.timeperiod;
          }
          legendData.push(sgName + "-" + area + "-" + tp);
          seri.push({
            name: sgName + "-" + area + "-" + tp,
            value: row.value,
          });
        });

        oData = {
          tooltip: {
            trigger: "item",
          },
          legend: {
            type: "scroll",
            orient: "vertical",
            right: 10,
            top: 20,
            bottom: 20,
            itemGap: 14,
            data: legendData,
            show: lgend,
            formatter: function (name) {
              return name.length > 17 ? name.substring(0, 34) + "..." : name;
            },
            tooltip: {
              show: true,
              trigger: "item",
            },
            textStyle: {
              color: "#333",
            },
          },
          series: [
            {
              name: "",
              type: "pie",
              radius: ["40%", "70%"],
              // center: ['40%', '50%'],
              data: seri,
              color: colorPalette,
              label: {
                show: false,
              },
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)",
                },
              },
            },
          ],
        };
      }
    } else if (type == "treemap") {
      // let colorPalette = ["#B8372B", "#CF655B", "#ED9C94", "#FFCBC6"].reverse();
      if (
        useCase == "UC2" ||
        useCase == "UC3" ||
        useCase == "UC5" ||
        useCase == "UC14"
      ) {
        //1-dimension multiple
        let iusArr = [];
        let vData = [];
        // let legendData = [];
        let tpName = "";
        showData.forEach((row) => {
          if (useCase == "UC2") {
            tpName = row.timeperiod;
          } else if (useCase == "UC3") {
            tpName = row.area;
          } else if (useCase == "UC5") {
            tpName = row.subgroup;
          } else if (useCase == "UC14") {
            tpName = row.indicator;
          }

          vData.push({ name: tpName, value: row.value });
          // tpName = row.time_period?.start_time_period;
        });

        oData = {
          tooltip: {
            formatter: function (info) {
              var value = info.value;
              var treePathInfo = info.treePathInfo;
              var treePath = [];
              for (var i = 1; i < treePathInfo.length; i++) {
                treePath.push(treePathInfo[i].name);
              }
              return [
                '<div class="tooltip-title">' +
                formatUtil.encodeHTML(treePath.join("/")) +
                "</div>",
                formatUtil.addCommas(value),
              ].join("");
            },
          },
          series: [
            {
              name: "",
              type: type,
              label: {
                show: false,
                formatter: function (params) {
                  let val = (+params.value).toLocaleString();
                  return `${params.data.name}, ${val}`;
                },
              },
              data: vData,
              color: colorPalette,

              breadcrumb: {
                show: true,
              },
              levels: [
                {
                  itemStyle: {
                    borderWidth: 0,
                    gapWidth: 5,
                  },
                },
                {
                  itemStyle: {
                    gapWidth: 1,
                  },
                },
                {
                  colorSaturation: [0.35, 0.5],
                  itemStyle: {
                    gapWidth: 1,
                    borderColorSaturation: 0.6,
                  },
                },
              ],
            },
          ],
        };
      } else if (
        useCase == "UC4" ||
        useCase == "UC6" ||
        useCase == "UC12" ||
        useCase == "UC13" ||
        useCase == "UC15" ||
        useCase == "UC16" ||
        useCase == "UC17" ||
        useCase == "UC18" ||
        useCase == "UC19" ||
        useCase == "UC20" ||
        useCase == "UC22" ||
        useCase == "UC23" ||
        useCase == "UC24"
      ) {
        //2-dimensions are multiple

        let legendData = [];
        let seri = [];
        showData.forEach((row) => {
          let sgName = row.area;
          let tp = row.timeperiod;
          if (useCase == "UC6") {
            sgName = row.subgroup;
            tp = row.area;
          } else if (useCase == "UC12") {
            sgName = row.timeperiod;
            tp = row.unit;
          } else if (useCase == "UC13") {
            sgName = row.area;
            tp = row.unit;
          } else if (useCase == "UC15") {
            sgName = row.subgroup;
            tp = row.unit;
          } else if (useCase == "UC16") {
            sgName = row.indicator;
            tp = row.unit;
          } else if (useCase == "UC17") {
            sgName = row.subgroup;
            tp = row.timeperiod;
          } else if (useCase == "UC18") {
            sgName = row.indicator;
            tp = row.timeperiod;
          } else if (useCase == "UC19") {
            sgName = row.indicator;
            tp = row.area;
          } else if (useCase == "UC20") {
            sgName = row.indicator;
            tp = row.subgroup;
          } else if (useCase == "UC22") {
            sgName = row.area;
            tp = row.unit;
          } else if (useCase == "UC23") {
            sgName = row.unit + "|" + row.subgroup;
            tp = row.timeperiod;
          } else if (useCase == "UC23") {
            sgName = row.unit + "|" + row.subgroup;
            tp = row.area;
          }
          // legendData.push(sgName+'-'+tp);
          seri.push({
            name: sgName + "-" + tp,
            value: row.value,
          });
        });

        oData = {
          tooltip: {
            formatter: function (info) {
              var value = info.value;
              var treePathInfo = info.treePathInfo;
              var treePath = [];
              for (var i = 1; i < treePathInfo.length; i++) {
                treePath.push(treePathInfo[i].name);
              }
              return [
                '<div class="tooltip-title">' +
                formatUtil.encodeHTML(treePath.join("/")) +
                "</div>",
                formatUtil.addCommas(value),
              ].join("");
            },
          },
          series: [
            {
              name: "",
              type: type,
              data: seri,
              color: colorPalette,
              label: {
                show: false,
              },
              breadcrumb: {
                show: true,
              },
            },
          ],
        };
      } else if (
        useCase == "UC7" ||
        useCase == "UC8" ||
        useCase == "UC9" ||
        useCase == "UC10" ||
        useCase == "UC11" ||
        useCase == "UC21" ||
        useCase == "UC25" ||
        useCase == "UC26" ||
        useCase == "UC27" ||
        useCase == "UC28" ||
        useCase == "UC29" ||
        useCase == "UC30" ||
        useCase == "UC31" ||
        useCase == "UC32"
      ) {
        //3+ dimensions are multiple
        let legendData = [];
        let seri = [];
        showData.forEach((row) => {
          let sgName = row.subgroup;
          let area = row.area;
          let tp = row.timeperiod;
          if (useCase == "UC8") {
            sgName = row.indicator;
            area = row.area;
            tp = row.timeperiod;
          } else if (useCase == "UC9") {
            sgName = row.indicator + "|" + row.unit;
            area = row.area;
            tp = row.timeperiod;
          } else if (useCase == "UC10") {
            sgName = row.indicator + "|" + row.unit + "|" + row.subgroup;
            area = row.area;
            tp = row.timeperiod;
          } else if (useCase == "UC11") {
            sgName = row.area;
            area = row.timeperiod;
            tp = row.unit;
          } else if (useCase == "UC21") {
            sgName = row.unit + "|" + row.subgroup;
            area = row.area;
            tp = row.timeperiod;
          } else if (useCase == "UC25") {
            sgName = row.indicator;
            area = row.subgroup;
            tp = row.area;
          } else if (useCase == "UC26") {
            sgName = row.indicator + "|" + row.subgroup;
            area = row.area;
            tp = row.timeperiod;
          } else if (useCase == "UC27") {
            sgName = row.indicator;
            area = row.subgroup;
            tp = row.timeperiod;
          } else if (useCase == "UC28") {
            sgName = row.indicator;
            area = row.unit;
            tp = row.timeperiod;
          } else if (useCase == "UC29") {
            sgName = row.indicator;
            area = row.unit;
            tp = row.area;
          } else if (useCase == "UC30") {
            sgName = row.indicator;
            area = row.unit;
            tp = row.subgroup;
          } else if (useCase == "UC31") {
            sgName = row.indicator + "|" + row.unit;
            area = row.subgroup;
            tp = row.area;
          } else if (useCase == "UC32") {
            sgName = row.indicator + "|" + row.unit;
            area = row.subgroup;
            tp = row.timeperiod;
          }
          // legendData.push(sgName+'-'+area+'-'+tp);
          seri.push({
            name: sgName + "-" + area + "-" + tp,
            value: row.value,
          });
        });

        oData = {
          tooltip: {
            formatter: function (info) {
              var value = info.value;
              var treePathInfo = info.treePathInfo;
              var treePath = [];
              for (var i = 1; i < treePathInfo.length; i++) {
                treePath.push(treePathInfo[i].name);
              }
              return [
                '<div class="tooltip-title">' +
                formatUtil.encodeHTML(treePath.join("/")) +
                "</div>",
                formatUtil.addCommas(value),
              ].join("");
            },
          },
          series: [
            {
              name: "",
              type: type,
              data: seri,
              color: colorPalette,
              label: {
                show: false,
              },
              breadcrumb: {
                show: true,
              },
            },
          ],
        };
      }
    } else if (type == "radar") {
      // let colorPalette = colorPaletteState;
      if (
        useCase == "UC2" ||
        useCase == "UC3" ||
        useCase == "UC5" ||
        useCase == "UC13" ||
        useCase == "UC14"
      ) {
        //1-dimension multiple
        let legendData = [];
        let tpArr = [];
        let vData = {};
        let max = 0;
        let seri = [];
        let sgNames = [];
        showData.forEach((row) => {
          let sgName = row.subgroup;
          let area = row.area;
          let tp = row.timeperiod;
          
          if (useCase == "UC2") {
            tp = row.timeperiod;
          } else if (useCase == "UC3") {
            area = row.area;
          } else if (useCase == "UC5") {
            sgName = row.subgroup;
          } else if (useCase == "UC14") {
            sgName = row.subgroup;
          } else if (useCase == "UC13") {
             tp = row.timeperiod;
          }
          // sgName = sgName;
          max = +row.value > max ? +row.value : max;
          if(!tpArr.includes(tp)) {
            tpArr.push(tp);
          }
          if(!(sgName in vData)) {
            vData[sgName] = {};
            sgNames.push(sgName);
          }
          vData[sgName][tp] = +row.value;
        });

        legendData = tpArr.map((ele) => {
          return { max: max, name: ele };
        });
        for(let sg in vData) {
          let value = [];
          for(let tp of tpArr) {
            if(tp in vData[sg]) {
              value.push(vData[sg][tp]);
            } else {
              value.push(null);
            }
          }
          seri.push({
            value: value,
            name: sg
          });
        }
        

        oData = {
          tooltip: {
            trigger: "item",
          },
          color: sgNames?.length == 1 ? colorPalette[5] : colorPalette,
          radar: {
            // shape: 'circle',
            indicator: legendData,
          },
          legend: {
            data: sgNames,
            // data: sgNames,
            orient: "vertical",
            top: "5%",
            // icon: 'rect',
            right: 0,
            bottom: 0,
            // height: 'auto',
            itemGap: 14,
            type: "scroll",
            show: lgend,
            formatter: function (name) {
              return name.length > 17 ? name.substring(0, 17) + "..." : name;
            },
            tooltip: {
              show: true,
              trigger: "item",
            },
            textStyle: {
              color: "#333",
            },
          },
          series: [
            {
              name: "",
              type: type,
              label: {
                show: false,
              },
              data: seri,
            },
          ],
        };
      } else if (
        useCase == "UC4" ||
        useCase == "UC6" ||
        useCase == "UC12" ||
        // useCase == "UC13" ||
        useCase == "UC15" ||
        useCase == "UC16" ||
        useCase == "UC17" ||
        useCase == "UC18" ||
        useCase == "UC19" ||
        useCase == "UC20" ||
        useCase == "UC22" 
        
      ) {
        //2-dimensions are multiple
        let legendData = [];
        let tpArr = [];
        let vData = {};
        let max = 0;
        let seri = [];
        let sgNames = [];
        showData.forEach((row) => {
          let sgName = row.area;
          let tp = row.timeperiod;
          if (useCase == "UC6") {
            sgName = row.subgroup;
            tp = row.area;
          } else if (useCase == "UC12") {
            sgName = row.timeperiod;
            tp = row.unit;
          } else if (useCase == "UC13") {
            sgName = row.area;
            tp = row.unit;
          } else if (useCase == "UC15") {
            sgName = row.subgroup;
            tp = row.unit;
          } else if (useCase == "UC16") {
            sgName = row.indicator;
            tp = row.unit;
          } else if (useCase == "UC17") {
            sgName = row.subgroup;
            tp = row.timeperiod;
          } else if (useCase == "UC18") {
            sgName = row.indicator;
            tp = row.timeperiod;
          } else if (useCase == "UC19") {
            sgName = row.indicator;
            tp = row.area;
          } else if (useCase == "UC20") {
            sgName = row.indicator;
            tp = row.subgroup;
          } else if (useCase == "UC22") {
            sgName = row.area;
            tp = row.unit;
          } 
          
          max = +row.value > max ? +row.value : max;
          if(!tpArr.includes(tp)) {
            tpArr.push(tp);
          }
          if(!(sgName in vData)) {
            vData[sgName] = {};
            sgNames.push(sgName);
          }
          vData[sgName][tp] = +row.value;
          // legendData.push({ name: sgName + "-" + tp });
          
          // vData.push(row.value);
          // tpName = row.time_period?.start_time_period;
        });
        
        legendData = tpArr.map((ele) => {
          return { max: max, name: ele };
        });
        for(let sg in vData) {
          let value = [];
          for(let tp of tpArr) {
            if(tp in vData[sg]) {
              value.push(vData[sg][tp]);
            } else {
              value.push(null);
            }
          }
          seri.push({
            value: value,
            name: sg
          });
        }

        oData = {
          tooltip: {
            trigger: "item",
          },
          color: sgNames?.length == 1 ? colorPalette[5] : colorPalette,
          radar: {
            // shape: 'circle',
            indicator: legendData,
          },
          legend: {
            data: sgNames,
            // data: sgNames,
            orient: "vertical",
            top: "5%",
            // icon: 'rect',
            right: 0,
            bottom: 0,
            // height: 'auto',
            itemGap: 14,
            type: "scroll",
            show: lgend,
            formatter: function (name) {
              return name.length > 17 ? name.substring(0, 17) + "..." : name;
            },
            tooltip: {
              show: true,
              trigger: "item",
            },
            textStyle: {
              color: "#333",
            },
          },
          series: [
            {
              name: "",
              type: type,
              label: {
                show: false,
              },
              data: seri,
            },
          ],
        };
      } else if (
        useCase == "UC7" ||
        useCase == "UC8" ||
        useCase == "UC9" ||
        useCase == "UC10" ||
        useCase == "UC11" ||
        useCase == "UC21" ||
        useCase == "UC25" ||
        useCase == "UC26" ||
        useCase == "UC27" ||
        useCase == "UC28" ||
        useCase == "UC29" ||
        useCase == "UC30" ||
        useCase == "UC31" ||
        useCase == "UC32" ||
        useCase == "UC23" ||
        useCase == "UC24"
      ) {
        //3+ dimensions are multiple
        let legendData = [];
        let tpArr = [];
        let vData = {};
        let max = 0;
        let seri = [];
        let sgNames = [];
        showData.forEach((row) => {
          let sgName = row.subgroup;
          let area = row.area;
          let tp = row.timeperiod;
          if (useCase == "UC8") {
            sgName = row.indicator;
            area = row.area;
            tp = row.timeperiod;
          } else if (useCase == "UC9") {
            sgName = row.indicator + "|" + row.unit;
            area = row.area;
            tp = row.timeperiod;
          } else if (useCase == "UC10") {
            sgName = row.indicator + "|" + row.unit + "|" + row.subgroup;
            area = row.area;
            tp = row.timeperiod;
          } else if (useCase == "UC11") {
            sgName = row.area;
            area = row.timeperiod;
            tp = row.unit;
          } else if (useCase == "UC21") {
            sgName = row.unit + "|" + row.subgroup;
            area = row.area;
            tp = row.timeperiod;
          } else if (useCase == "UC25") {
            sgName = row.indicator;
            area = row.subgroup;
            tp = row.area;
          } else if (useCase == "UC26") {
            sgName = row.indicator + "|" + row.subgroup;
            area = row.area;
            tp = row.timeperiod;
          } else if (useCase == "UC27") {
            sgName = row.indicator;
            area = row.subgroup;
            tp = row.timeperiod;
          } else if (useCase == "UC28") {
            sgName = row.indicator;
            area = row.unit;
            tp = row.timeperiod;
          } else if (useCase == "UC29") {
            sgName = row.indicator;
            area = row.unit;
            tp = row.area;
          } else if (useCase == "UC30") {
            sgName = row.indicator;
            area = row.unit;
            tp = row.subgroup;
          } else if (useCase == "UC31") {
            sgName = row.indicator + "|" + row.unit;
            area = row.subgroup;
            tp = row.area;
          } else if (useCase == "UC32") {
            sgName = row.indicator + "|" + row.unit;
            area = row.subgroup;
            tp = row.timeperiod;
          } else if (useCase == "UC23") {
            sgName = row.unit;
            area = row.subgroup;
            tp = row.timeperiod;
          } else if (useCase == "UC23") {
            sgName = row.unit;
            area = row.subgroup;
            tp = row.area;
          }
          sgName = sgName+'-'+area;
          max = +row.value > max ? +row.value : max;
          if(!tpArr.includes(tp)) {
            tpArr.push(tp);
          }
          if(!(sgName in vData)) {
            vData[sgName] = {};
            sgNames.push(sgName);
          }
          vData[sgName][tp] = +row.value;
          
        });

        legendData = tpArr.map((ele) => {
          return { max: max, name: ele };
        });
        for(let sg in vData) {
          let value = [];
          for(let tp of tpArr) {
            if(tp in vData[sg]) {
              value.push(vData[sg][tp]);
            } else {
              value.push(null);
            }
          }
          seri.push({
            value: value,
            name: sg
          });
        }

        oData = {
          tooltip: {
            trigger: "item",
          },
          color: sgNames?.length == 1 ? colorPalette[5] : colorPalette,
          radar: {
            // shape: 'circle',
            indicator: legendData,
          },
          legend: {
            data: sgNames,
            // data: sgNames,
            orient: "vertical",
            top: "5%",
            // icon: 'rect',
            right: 0,
            bottom: 0,
            // height: 'auto',
            itemGap: 14,
            type: "scroll",
            show: lgend,
            formatter: function (name) {
              return name.length > 17 ? name.substring(0, 17) + "..." : name;
            },
            tooltip: {
              show: true,
              trigger: "item",
            },
            textStyle: {
              color: "#333",
            },
          },
          series: [
            {
              name: "",
              type: type,
              label: {
                show: false,
              },
              data: seri,
            },
          ],
        };
      }
    }

    return oData;
  };


  useEffect(() => {
    renderChart(uCase, type);
  }, [indicator, timeperiod, zoomData, showData]);

  const onChange = (val, key, e = null) => {
    let ind = '';
    let tp = '';
    switch (key) {
      // case "disaster":
      //   setDisaster(val);
      //   setForm(mapState.uniForms?.[val][0]);
      //   ind = mapState.uniNewIndicators?.[val+'-'+mapState.uniForms?.[val][0]][0];
      //   setIndicator(ind);
      //   tp = mapState.uniTP?.[val+'-'+mapState.uniForms?.[val][0]+ind.indicator+'-'+ind.unit+'-'+ind.subgroup][0];
      //   setTimeperiod(tp);
      //   setSource(mapState.uniSrc?.[val+'-'+mapState.uniForms?.[val][0]+ind.indicator+'-'+ind.unit+'-'+ind.subgroup+'-'+tp][0]);
      //   break;
      // case "form":
      //   setForm(val);
      //   ind = mapState.uniNewIndicators?.[disaster+val][0];
      //   setIndicator(ind);
      //   tp = mapState.uniTP?.[disaster+'-'+val+ind.indicator+'-'+ind.unit+'-'+ind.subgroup][0];
      //   setTimeperiod(tp);
      //   setSource(mapState.uniSrc?.[disaster +'-'+ val+ind.indicator+'-'+ind.unit+'-'+ind.subgroup+'-'+tp][0]);
      //   break;
      case "indicator":
        setIndicator(val);
        tp = mapState.uniTP?.[val.indicator + '-' + val.unit + '-' + val.subgroup][0];
        setTimeperiod(tp);
        setFlag(true);
        setITFlag(false);
        setSource(mapState.uniSrc?.[val.indicator + '-' + val.unit + '-' + val.subgroup + '-' + tp]);
        break;
      case "timeperiod":
        setTimeperiod(val);
        setFlag(true);
        setITFlag(false);
        setSource(mapState.uniSrc?.[indicator.indicator + '-' + indicator.unit + '-' + indicator.subgroup + '-' + val]);
        break;
      case "src":
        setFlag(true);
        let s = JSON.parse(JSON.stringify(source));
        if (val == '*') {
          if (e.target.checked) {
            if (type == 'map') {
              s = mapState.uniSrc ? mapState.uniSrc[indicator.indicator + '-' + indicator.unit + '-' + indicator.subgroup + '-' + timeperiod] : [];
            } else {
              s = JSON.parse(JSON.stringify(srcList));
            }
            if (!s.includes('*')) {
              s.push(val);
            }
            setShowAllSelected(true);
          } else {
            s = [];
            setShowAllSelected(false);
          }
        } else if (e.target.checked) {
          s.push(val);
          let ss = false;
          if (type == 'map' && mapState.uniSrc?.[indicator.indicator + '-' + indicator.unit + '-' + indicator.subgroup + '-' + timeperiod]?.length == s?.length) {
            s.push('*');
            ss = true;
          } else if (type != 'map' && srcList?.length == s?.length) {
            s.push('*');
            ss = true;
          }
          setShowAllSelected(ss);
        } else {
          s = s.filter(x => x != '*' && x != val);
          setShowAllSelected(false);
        }
        setSource(s);
        break;
    }
  };

  const zoomin = () => {
    if (zoomData < 5) {
      setZoomData(zoomData + 0.2);
    }
  };

  const zoomout = () => {
    if (zoomData > 1) {
      setZoomData(zoomData - 0.2);
    }
  };

  const reset = () => {
    setZoomData(1.25);
  };

  const legendFormatter = (value) => {
    if (isNaN(value)) {
      return "No Data";
    }
    return value;
  };

  const onSwap = (temp) => {
    // renderChart(uCase, type, temp);
    setSwap(temp);
    setLabel(false);
  };

  const getLegendData = (mapData) => {

    if (mapData != null && mapData.length > 0) {
      let valueData = [];
      // let colors = ["#FFCBC6", "#ED9C94", "#CF655B", "#B8372B"];
      // ["#D2D2D2", "#ED9C94", "#CF655B", "#B8372B", "#FFCBC6"],
      let colors = ["#FFCBC6", "#ED9C94", "#CF655B", "#B8372B"];

      // let areaObj = mapData?.filter((o) => o.code == "TTO");

      // setTotal(areaObj?.[0]);
      // setDupTotal(areaObj?.[0]);

      mapData?.forEach((item) => {
        if (item.code != "TTO" && item?.value !== "") {
          valueData.push(+item.value);
        }
      });
      let s = new Set(valueData);
      let unicValData = [...s];

      unicValData.sort(function (a, b) {
        return a - b;
      });

      let unitVal = 1;

      var finalLegends = [];
      var collectionAreaData = [];
      if (unicValData?.length >= 4) {
        unitVal = Math.floor(unicValData?.length / 5);
      }
      let j = 0;
      let k = 0;
      let from = unicValData[0];
      let to = unicValData[0];
      if (from == null) {
        return { legends: finalLegends, collection: collectionAreaData };
      }
      for (let i = 0; i < unicValData.length; i++) {
        if (j++ >= unitVal && k < 3) {
          j = 0;

          let obj = {
            color: colors[k++],
            label: "" + from + " - " + to,
            min: parseFloat(from),
            max: parseFloat(to),
          };
          let decimalLengths = from = to?.toString().split('.')[1]?.length
          if (decimalLengths === 1) {
            let adon = +to + 0.1;
            from = parseFloat(adon.toFixed(2))
            to = +to + 1;
            //  min = parseFloat(adon.toFixed(2))
            //  max= parseFloat(to)

          } else if (decimalLengths === 2) {
            let adon = +to + 0.01
            from = parseFloat(adon.toFixed(2))
            //   min = parseFloat(adon.toFixed(2))
            //   max= parseFloat(to)

          }
          else {
            from = +to + 1
          }



          if (!isNaN(obj?.min) && !isNaN(obj?.max)) {
            finalLegends.push(obj);
          }
        }

        let valMapData = mapData?.filter(
          (item) => item.value == unicValData[i] && item.code != "TTO"
        );
        valMapData.forEach((item) => {
          if (item?.value !== "") {
            let obj = {
              color: colors[k],
              value: item.value,
              area: item.area,
              code: item.code,
            };
            collectionAreaData.push(obj);
          }
        });
        to = unicValData[i];
      }

      let obj = {
        color: colors[k++],
        label: "" + from + " - " + to,
        min: parseFloat(+from),
        max: parseFloat(+to)
      };
      if (!isNaN(obj?.min) && !isNaN(obj?.max)) {
        finalLegends.push(obj);
      }
      if (finalLegends?.length > 0) {
        finalLegends.push({ "color": "#e2e2e2", "label": "No Data", "max": 0, "min": 0 })
        // this.setState({ legends: finalLegends, collection: collectionAreaData })

      }
      // finalLegends.push({
      //   color: "#FFCBC6",
      //   label: "No Data",
      //   value: NaN,
      //   symbol: 'circle'
      // });

      // this.setState({ legends: finalLegends, collection: collectionAreaData })
      setLegend(finalLegends);
      return { legends: finalLegends, collection: collectionAreaData };
    }
    return null;
  };

  const src_change = () => {
    $('body').addClass('src_list');
  }
  const fullpage = () => {
    $('#analysis-modal').addClass('fullscreen');
    $('.expand_btn').hide();
    $('.collapse_btn').show();
  }

  const Exitfullpage = () => {
    $('#analysis-modal').removeClass('fullscreen');
    $('.collapse_btn').hide();
    $('.expand_btn').show();
  }
  return (
    <>
      <div id="og" className={type == "map" ? "position-relative" : ""}>
        <div
          className={
            type == "map" ? "dsr_barchart dsr_Mapchart" : "dsr_barchart"
          }
        >
          {type == "map" && (
            <div className="dsrDropdown">
              <ul className="pl-0">
                <li>
                  {/* <span>Indicator</span> */}

                  <Dropdown>
                    <Dropdown.Toggle variant="success" id="dropdown-basic">
                      {indicator?.indicator}{" "}
                      <span>
                        {" | " + indicator?.unit + " | " + indicator?.subgroup}
                      </span>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      {mapState?.uniNewIndicators?.map((x) => {
                        return (
                          <Dropdown.Item
                            onClick={(e) => {
                              onChange(x, "indicator");
                            }}
                          >
                            {x.indicator}{" "}
                            <span>{" | " + x.unit + " | " + x.subgroup}</span>
                          </Dropdown.Item>
                        );
                      })}
                    </Dropdown.Menu>
                  </Dropdown>
                </li>
                <li>
                  {/* <span>Time Period</span> */}
                  <Dropdown>
                    <Dropdown.Toggle variant="success" id="dropdown-basic">
                      {timeperiod}
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      {mapState?.uniTP?.[indicator?.indicator + '-' + indicator?.unit + '-' + indicator?.subgroup]
                        ?.sort((a, b) => b.localeCompare(a)) // Sort the array in descending order
                        .map((x) => (
                          <Dropdown.Item
                            onClick={(e) => {
                              onChange(x, "timeperiod");
                            }}
                          >
                            {x}
                          </Dropdown.Item>
                        ))}
                    </Dropdown.Menu>
                  </Dropdown>

                </li>
              </ul>
            </div>
          )}

          <div className="dsrBarchart_section">
            <div className="dsrBarchart_list charts_area_drop">
              <Dropdown alignRight disabled={dat?.length ? false : true}>
                <Dropdown.Toggle variant="light" className="btn burger-menu bg-transparent border-0"
                  disabled={dat?.length ? false : true} type="button" data-toggle="dropdown" aria-expanded="false">
                  <img src="assets/lib/images/new-home/chart_hum.svg" alt="" />
                </Dropdown.Toggle>
                <Dropdown.Menu>

                  {(type !== "map" && type != 'table') &&
                    <Dropdown.Item disabled={dat?.length ? false : true} onClick={(e) => { ChartlabelNev(); }}>
                      {/* <img id="label" src="assets/lib/images/home/label_on.svg" /> */}
                      {label && (
                      <div title={dataSearchResultLang?.["labelOff"]?.[lang]} placement="right" onClick={(e) => showLabel()}>                       
                          <img
                            // src="assets/lib/images/home/label_on.svg"
                            src="assets/lib/images/home/label-off.svg"
                            alt="onof"
                            className="img-label"
                          />
                       
                      </div>
                    )}
                    {!label && (
                      <div title={dataSearchResultLang?.["labelOn"]?.[lang]} placement="right" onClick={(e) => showLabel()}>                     
                          <img
                            // src="assets/lib/images/home/label-off.svg"
                            src="assets/lib/images/home/label_on.svg"
                            alt="on"
                            className="img-label"
                          />                       
                      </div>
                    )}
                    </Dropdown.Item>
                  }
                  {(type !== "map" && type != 'table') &&
                    <Dropdown.Item disabled={dat?.length ? false : true} onClick={(e) => { chartLegend(); }}>
                      {/* <img id="label" src="assets/lib/images/home/label_on.svg" /> */}
                      {lgend && (
                      <div title={dataSearchResultLang?.["legendoff"]?.[lang]} placement="right" onClick={(e) => showLegend()}>                       
                          <img
                            // src="assets/lib/images/home/label_on.svg"
                            src="assets/lib/images/home/legend-off.svg"
                            alt="onof"
                            className="img-label"
                          />
                       
                      </div>
                    )}
                    {!lgend && (
                      <div title={dataSearchResultLang?.["legendOn"]?.[lang]} placement="right" onClick={(e) => showLegend()}>                     
                          <img
                            // src="assets/lib/images/home/label-off.svg"
                            src="assets/lib/images/home/legend-on.svg"
                            alt="on"
                            className="img-label"
                          />                       
                      </div>
                    )}
                    </Dropdown.Item>
                  }
                  {(type !== "map" &&
                    type != 'table' &&
                    type !== "pie" &&
                    type !== "doughnut" &&
                    type !== "radar" &&
                    type !== "treemap"
                  ) &&  <Dropdown.Item title="Swap" disabled={dat?.length ? false : true} onClick={(e) => { onSwap(!swap) }}> <img src="assets/lib/images/home/resets.svg" /></Dropdown.Item>}
                
                  <Dropdown.Item title="Download" disabled={dat?.length ? false : true} onClick={() => { downloadChart() }} ><img src="assets/lib/images/home/download.svg" /></Dropdown.Item>
                  {/* <Dropdown.Item className='expand_btn' onClick={() => { fullpage() }} ><img src="assets/lib/images/home/icon_expand.svg" /></Dropdown.Item> */}
               
                  <Dropdown.Item title="Collapse" style={{ display: 'none' }} className='collapse_btn' onClick={() => { Exitfullpage() }} ><img src="assets/lib/images/home/icon_collapse.svg" /></Dropdown.Item>
            
                  <Dropdown.Item title="Share" className='position-relative multiCollapseShare'> 
                    <a data-toggle="dropdown" className='action_icon p-0'>
                    <img src="assets/lib/images/charts/share.svg"/>   
                    </a>
                    <div className='shareBtn'>
                      <ul className="">
                        <li>
                        <button>
                        { console.log(props,"props.dataId")}
                        <FacebookShareButton
                          ref={fbShareButton}
                          openShareDialogOnClick={url !== "none"} 
                          url={url} 
                          quote={"title"} 
                          onClick={()=>onClick('fb')}
                        >

                        {/* <svg viewBox="0 0 64 64" width="25" height="25"><rect width="64" height="64" rx="0" ry="0" fill="#3b5998"></rect><path d="M34.1,47V33.3h4.6l0.7-5.3h-5.3v-3.4c0-1.5,0.4-2.6,2.6-2.6l2.8,0v-4.8c-0.5-0.1-2.2-0.2-4.1-0.2 c-4.1,0-6.9,2.5-6.9,7V28H24v5.3h4.6V47H34.1z" fill="white"></path></svg> */}

                        <FacebookIcon size={25} />
                        </FacebookShareButton>
                          </button>
                        </li>
                        <li>
                          <button>
                          <TwitterShareButton 
                            ref={twShareButton}
                            openShareDialogOnClick={url !== "none"} 
                            url={url} 
                            quote={"title"} 
                            onClick={()=>onClick('tw')}
                            className='twitter_icon'
                          >
                          {/* <svg viewBox="0 0 64 64" width="25" height="25"><rect width="64" height="64" rx="0" ry="0" fill="#00aced"></rect><path d="M48,22.1c-1.2,0.5-2.4,0.9-3.8,1c1.4-0.8,2.4-2.1,2.9-3.6c-1.3,0.8-2.7,1.3-4.2,1.6 C41.7,19.8,40,19,38.2,19c-3.6,0-6.6,2.9-6.6,6.6c0,0.5,0.1,1,0.2,1.5c-5.5-0.3-10.3-2.9-13.5-6.9c-0.6,1-0.9,2.1-0.9,3.3 c0,2.3,1.2,4.3,2.9,5.5c-1.1,0-2.1-0.3-3-0.8c0,0,0,0.1,0,0.1c0,3.2,2.3,5.8,5.3,6.4c-0.6,0.1-1.1,0.2-1.7,0.2c-0.4,0-0.8,0-1.2-0.1 c0.8,2.6,3.3,4.5,6.1,4.6c-2.2,1.8-5.1,2.8-8.2,2.8c-0.5,0-1.1,0-1.6-0.1c2.9,1.9,6.4,2.9,10.1,2.9c12.1,0,18.7-10,18.7-18.7 c0-0.3,0-0.6,0-0.8C46,24.5,47.1,23.4,48,22.1z" fill="white"></path></svg> */}
                          {/* <TwitterIcon size={25} /> */}
                          <img src="assets/images/twitter.svg"/>
                          </TwitterShareButton>
                          </button>
                        </li>
                        <li>
                          <button>
                          <LinkedinShareButton 
                            ref={lnShareButton}
                            openShareDialogOnClick={url !== "none"} 
                            url={url} 
                            quote={"title"} 
                            onClick={()=>onClick('ln')}
                          >
                          {/* <svg viewBox="0 0 64 64" width="25" height="25"><rect width="64" height="64" rx="0" ry="0" fill="#007fb1"></rect><path d="M20.4,44h5.4V26.6h-5.4V44z M23.1,18c-1.7,0-3.1,1.4-3.1,3.1c0,1.7,1.4,3.1,3.1,3.1 c1.7,0,3.1-1.4,3.1-3.1C26.2,19.4,24.8,18,23.1,18z M39.5,26.2c-2.6,0-4.4,1.4-5.1,2.8h-0.1v-2.4h-5.2V44h5.4v-8.6 c0-2.3,0.4-4.5,3.2-4.5c2.8,0,2.8,2.6,2.8,4.6V44H46v-9.5C46,29.8,45,26.2,39.5,26.2z" fill="white"></path></svg> */}
                          <LinkedinIcon size={25} />
                          </LinkedinShareButton>
                          </button>
                        </li>
                      </ul>
                      </div>
                    
                  </Dropdown.Item>
              

                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
          <div className="drsIndicators">
            <div className="drsIndicators_text">
              {props.type == "map" ? "" : title}
            </div>
          </div>
        </div>
        <div
          className={
            showData?.length == 1
              ? "single-value drsChartss dsrChartBox"
              : "multiple-value drsChartss dsrChartBox"
          }
        >
          <div
            ref={chart}
            className={type == "map" ? "chartsdsr chartdsrMap" : "chartsdsr chartlayout"}
          />
          {type != "map" &&<div className="tooltip">I'm a tooltip!</div>}

          {type == "map" && (
            <>
              {isCompass == true && (
                <span class="comapss datasearchCompass">
                  <img src="assets/map/compass.svg" />
                </span>
              )}
              <div className="legends">
                <ul>
                  <li>
                    <Tooltip title={dataSearchResultLang?.["zoomIn"]?.[lang]} placement="right">
                      <a
                        style={{ cursor: "pointer" }}
                        to=""
                        onClick={(e) => zoomin()}
                      >
                        <img src="assets/lib/images/home/zoom-in.svg" />
                      </a>
                    </Tooltip>
                  </li>
                  <li>
                    <Tooltip title={dataSearchResultLang?.["zoomOut"]?.[lang]} placement="right">
                      <a
                        style={{ cursor: "pointer" }}
                        to=""
                        onClick={(e) => zoomout()}
                      >
                        <img src="assets/lib/images/home/zoom-out.svg" />
                      </a>
                    </Tooltip>
                  </li>
                  <li className="wmtm_reset">
                    <Tooltip title={dataSearchResultLang?.["reset"]?.[lang]} placement="right">
                      <a
                        style={{ cursor: "pointer" }}
                        to=""
                        onClick={(e) => reset()}
                      >
                        <img src="assets/lib/images/home/reset.svg" />
                      </a>
                    </Tooltip>
                  </li>
                  <li>
                    {label && (
                      <Tooltip title={dataSearchResultLang?.["labelOff"]?.[lang]} placement="right">
                        <a
                          style={{ cursor: "pointer" }}
                          onClick={(e) => showLabel()}
                        >
                          <img
                            // src="assets/lib/images/home/label_on.svg"
                            src="assets/lib/images/home/label-off.svg"
                            alt="onof"
                            className="img-label"
                          />
                        </a>
                      </Tooltip>
                    )}
                    {!label && (
                      <Tooltip title={dataSearchResultLang?.["labelOn"]?.[lang]} placement="right">
                        <a
                          style={{ cursor: "pointer" }}
                          onClick={(e) => showLabel()}
                        >
                          <img
                            // src="assets/lib/images/home/label-off.svg"
                            src="assets/lib/images/home/label_on.svg"
                            alt="on"
                            className="img-label"
                          />
                        </a>
                      </Tooltip>
                    )}
                  </li>
                  <li>
                    <Tooltip title={dataSearchResultLang?.["northPole"]?.[lang]} placement="right">
                      <a
                        to=""
                        style={{ cursor: "pointer" }}
                        onClick={(e) => toggleCompass()}
                      >
                        <img src="assets/lib/images/home/north_pole.svg" />
                      </a>
                    </Tooltip>
                  </li>
                </ul>
              </div>
              {!noData &&
                <div class="legendsNumber legendsChart">
                  <p> {indicator?.unit}</p>
                  <ul>
                    {
                      legend?.map((l, i) => {
                        return (<li>
                          <span class={"lnColor" + (i + 1)}>

                          </span>{l.label}</li>
                        )
                      })
                    }

                    <li>
                      <span class="lnColor5">
                        No Data

                      </span> {dataSearchResultLang.noData[lang]}
                    </li>
                  </ul>
                </div>
              }

              <div className={type === "map" ? "drs_sources drs_sourcesMap chartSource" : "drs_sources"}>
                <span>Source</span>
                  {/* <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={source}
                    multiple
                    label="Source"
                    renderValue={(selected) => {
                      if (selected.length === 1) {
                        return selected[0]; // Display name of the single selected item
                      } else if (!source?.includes('*') && selected.length > 1) {
                        return `${selected.length} Selected`; // Display number of selected items
                      } else if (source?.includes('*')) {
                        return 'All Selected';
                      }
                    }}
                    onMouseDown={() => { src_change() }}
                  > */}
                  <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={source}
                        multiple
                        label="Source"
                        onMouseDown={src_change}
                        onChange={(e) => {
                          // Update the source state and check if "All Selected" should be displayed
                          const selectedSources = e.target.value;
                          setSource(selectedSources);
                          if(selectedSources.length === source.length && selectedSources.length > 0) {
                            setShowAllSelected(true);
                          } else {
                            setShowAllSelected(false);
                          }
                          
                        }}
                        renderValue={(selected) => {
                          const selectedSources = source.filter((item) => selected.includes(item));

                          if (selectedSources.length === 1) {
                            return selectedSources[0]; // Display the name of the single selected source
                          } else if (showAllSelected) {
                            return 'All Selected'; // Display "All Selected" when appropriate
                          } else if (selected?.filter((x)=> x!=='*')?.length === 1 ) {
                            return `${selected?.filter((x)=> x!=='*')}`; // Display the count of selected items
                          }
                          return 'Select Source';
                        }}
                      >
                    <MenuItem>
                      <Checkbox
                        checked={source?.includes('*')}
                        onChange={(e) => {
                          onChange('*', "src", e);
                        }}
                      />
                      Select All
                    </MenuItem>
                    {mapState?.uniSrc?.[indicator?.indicator + '-' + indicator?.unit + '-' + indicator?.subgroup + '-' + timeperiod]
                      ?.filter(x => x !== '*')
                      ?.map((x) => (
                        <MenuItem key={x}>
                          <Checkbox
                            checked={source?.includes(x)}
                            onChange={(e) => {
                              onChange(x, "src", e);
                            }}
                          />
                          {x}
                        </MenuItem>
                      ))}
                  </Select>
              </div>


              <div className="mapSource-hide">
                <span> Source : {source?.filter(x=> x !=="*")?.join(', ')}</span>

              </div>

            </>
          )}

        </div>

        <div id="downloadchartds" className="downloadchartds">
          <div className={type === "map" ? "d-none" : "drs_sources chartSource"}>
            {/* <span className="csd_sourceNone">Source</span> */}
              {/* <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={source}
                multiple
                label="Source"
                onMouseDown={src_change}
                renderValue={(selected) => {

                  if (selected.length === 1) {
                    return selected[0]; // Display name of the single selected item
                  } else if (!source?.includes('*') && selected.length > 1) {
                    return `${selected.length} Selected`; // Display number of selected items
                  } else if (source?.includes('*')) {
                    return 'All Selected';
                  }
                  const uniqueSelected = [...new Set(selected)]; // Convert selected to a Set and back to an array to remove duplicates
                  return uniqueSelected.join(', ');
                }}
              > */}
              <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={source}
                        multiple
                        label="Source"
                        onMouseDown={src_change}
                        onChange={(e) => {
                          // Update the source state and check if "All Selected" should be displayed
                          const selectedSources = e.target.value;
                          setSource(selectedSources);
                          if(selectedSources.length === source.length && selectedSources.length > 0) {
                            setShowAllSelected(true);
                          } else {
                            setShowAllSelected(false);
                          }
                        }}
                        renderValue={(selected) => {
                          const selectedSources = source.filter((item) => selected.includes(item));

                          if (selectedSources.length === 1) {
                            return selectedSources[0]; // Display the name of the single selected source
                          } else if (showAllSelected) {
                            return 'All Selected'; // Display "All Selected" when appropriate
                          } else if (selected?.filter((x)=> x!=='*')?.length === 1 ) {
                            return `${selected?.filter((x)=> x!=='*')}`; // Display the count of selected items
                          }
                          return 'Select Source';
                        }}
                      >
                <MenuItem>
                  <label className="cursor">
                      <Checkbox
                        checked={source?.includes('*')}
                        onChange={(e) => {
                          onChange('*', "src", e);
                        }}
                      />
                      Select All
                    </label>
                </MenuItem>
                {srcList?.filter(x => x !== '*')?.map((x) => (
                  <MenuItem key={x}>
                   <label className="cursor">
                        <Checkbox
                          checked={source?.includes(x)}
                          onChange={(e) => {
                            onChange(x, "src", e);
                          }}
                        />
                        {x}
                    </label>
                  </MenuItem>
                ))}
              </Select>
              <div className="newSource">
                <span> Source : {source?.filter(x=> x !=="*")?.join(', ')}</span>
            </div>
          </div>
          {/* </div> */}
        </div>
      </div>
      <div className="downloadChartBG">
        <div id="copy" className="" style={{ display: "none" }}></div>
      </div>
      <div
        className={loader ? "loader text-center " : "loader text-center hide"}
      >
        <img
          src="assets/images/Comp-2.gif"
          style={{ marginTop: "12%", width: "30%" }}
        />
      </div>
    </>
  );
}

//indicator, unit, subgroup, area, timeperiod
const useCaseMatrix = {
  1: {
    //indicator
    1: {
      //unit
      1: {
        //subgroup
        1: {
          //area
          1: {
            //timeperiod
            useCase: "UC1",
          },
          2: {
            useCase: "UC2",
          },
        },
        2: {
          1: {
            useCase: "UC3",
          },
          2: {
            useCase: "UC4",
          },
        },
      },
      2: {
        1: {
          1: {
            useCase: "UC5",
          },
          2: {
            useCase: "UC17",
          },
        },
        2: {
          1: {
            useCase: "UC6",
          },
          2: {
            useCase: "UC7",
          },
        },
      },
    },
    2: {
      1: {
        1: {
          1: {
            useCase: "UC13",
          },
          2: {
            useCase: "UC12",
          },
        },
        2: {
          1: {
            useCase: "UC22",
          },
          2: {
            useCase: "UC11",
          },
        },
      },
      2: {
        1: {
          1: {
            useCase: "UC15",
          },
          2: {
            useCase: "UC23",
          },
        },
        2: {
          1: {
            useCase: "UC24",
          },
          2: {
            useCase: "UC21",
          },
        },
      },
    },
  },
  2: {
    1: {
      1: {
        1: {
          1: {
            useCase: "UC14",
          },
          2: {
            useCase: "UC18",
          },
        },
        2: {
          1: {
            useCase: "UC19",
          },
          2: {
            useCase: "UC8",
          },
        },
      },
      2: {
        1: {
          1: {
            useCase: "UC20",
          },
          2: {
            useCase: "UC27",
          },
        },
        2: {
          1: {
            useCase: "UC25",
          },
          2: {
            useCase: "UC26",
          },
        },
      },
    },
    2: {
      1: {
        1: {
          1: {
            useCase: "UC16",
          },
          2: {
            useCase: "UC28",
          },
        },
        2: {
          1: {
            useCase: "UC29",
          },
          2: {
            useCase: "UC9",
          },
        },
      },
      2: {
        1: {
          1: {
            useCase: "UC30",
          },
          2: {
            useCase: "UC32",
          },
        },
        2: {
          1: {
            useCase: "UC31",
          },
          2: {
            useCase: "UC10",
          },
        },
      },
    },
  },
};

export default DataSearchResultChart;